(
    function (skyward, $, undefined)
    {
        skyward.matrix = skyward.tooltip || {};

        var scheduleMatrixModule;
        var scheduleMatrixController;

        var outerMostContainerID = "[id*='studentSchedule-']";
        var studentScheduleViewPart;

        var allScheduleMatrixID = ".studentScheduleMatrix";
        var allStudentScheduleViewParts;

        var bottomTabContainerID = '#bottomTabContainer';
        var bottomTabContainer;
        var bottomTabCourseContainerID = "#bottomTabContainerCourse";
        var bottomTabCourseContainer;
        var rightTabCourseRequestContainerID = "#rightSliderPanel";

        var studentCourseRequestBrowse = 'StudentCourseRequestBrowse';
        var studentCourseAlternateRequest = 'StudentCourseAlternateRequest';
        var studentSectionScheduleListBrowse = 'StudentSections';
        var studentCourseRequestScheduleListBrowse = 'StudentCourseRequests';
        var studentAlternateRequestScheduleListBrowse = 'StudentAlternateRequests';
        var studentCombineRequestScheduleListBrowse = 'StudentCombineRequests';
        var actionMenuID = '#ActionMenu';
        var quickEntryCourseEELID = '#quickEntryCourse';
        var quickEntrySectionEELID = '#quickEntrySection';
        var quickEntryToolbarAddCourseButtonID = "#btnQuickEntryToolbarAddCourse";
        var quickEntryToolbarClearButtonID = "#btnQuickEntryToolbarClear";
        var btnCourseQuickEntryID = "#btnCourseQuickEntry";
        var cmbSpecifiedEntityID = "#cmbSpecifiedEntityID";
        var btnSettingsID = "#btnSettings";
        var btnScheduleBuilderLegendID = "[id$=btnScheduleBuilderLegend]";
        var effectiveDatePickerID = "#effectiveDate";
        var btnViewCourseBrowseID = "#btnViewCourseBrowse";

        var actionsMenu;
        var actionsMenuDeleteButton;
        var actionsMenuEditButton;
        var actionsMenuUnscheduleButton;
        var actionsMenuDropButton;
        var actionsMenuChangeButton;
        var actionsMenuReplaceButton;
        var availableSectionsCancelButton;
        var matrixBodyClickAdded = false;
        var preventDeselectTargetClick = false;
        var preventDeselectBodyClick = false;
        var previouslySelectStudentSectionID = "";

        var availableSectionsBrowse = 'AvailableSectionsBrowse';
        var availableSectionsByRequestsAndOpenPeriodBrowse = 'AvailableSectionsByRequestsAndOpenPeriodBrowse';
        var availableSectionsByOpenPeriodBrowse = 'AvailableSectionsByOpenPeriodBrowse';
        var availableSectionsByChangeSectionBrowse = 'AvailableSectionsByChangeSectionsBrowse';
        var availableSectionsByReplaceSectionBrowse = 'AvailableSectionsByReplaceSectionsBrowse';
        var availableSectionsByOpenSectionsBrowse = 'AvailableSectionsByOpenSectionsBrowse';
        var availableSectionsByOpenSectionsBrowseView = 'AvailableSectionsByOpenSectionsBrowseView';
        var availableCoursesBrowse = 'AvailableCoursesBrowse';
        var availableCoursesBrowseView = 'AvailableCoursesBrowseView';
        var availableSectionsView = 'AvailableSectionsView';

        var AccessMode = $('#accessmode').val();

        var init = function (selector)
        {
            studentScheduleViewPart = $(outerMostContainerID);

            if (!studentScheduleViewPart.length)
            {
                return;
            }

            initScreen(selector);
        };

        var initScreen = function (selector)
        {
            allStudentScheduleViewParts = $(allScheduleMatrixID);
            bottomTabContainer = $(bottomTabContainerID);
            bottomTabCourseContainer = $(bottomTabCourseContainerID);

            scheduleMatrixModule = studentScheduleViewPart.data("schedulematrixmodule");
            scheduleMatrixController = studentScheduleViewPart.data("schedulematrixcontroller");

            studentScheduleViewPart.off('change', '.cbScheduleType', skyward.matrix.scheduleTypeEventHandler);
            studentScheduleViewPart.on('change', '.cbScheduleType', skyward.matrix.scheduleTypeEventHandler);

            studentScheduleViewPart.off('change', '#cbMonthOfYear', skyward.matrix.weeklyScheduleMonthEventHandler);
            studentScheduleViewPart.on('change', '#cbMonthOfYear', skyward.matrix.weeklyScheduleMonthEventHandler);

            studentScheduleViewPart.off('change', '#cbWeekOfYear', skyward.matrix.weeklyScheduleWeekEventHandler);
            studentScheduleViewPart.on('change', '#cbWeekOfYear', skyward.matrix.weeklyScheduleWeekEventHandler);

            $('#cbMonthOfYear').off('change', skyward.matrix.weeklyScheduleMonthEventHandler);
            $('#cbMonthOfYear').on('change', skyward.matrix.weeklyScheduleMonthEventHandler);

            $('#cbWeekOfYear').off('change', skyward.matrix.weeklyScheduleWeekEventHandler);
            $('#cbWeekOfYear').on('change', skyward.matrix.weeklyScheduleWeekEventHandler);

            $('#cbScheduleDateRangeMode').off('change', skyward.matrix.dateRangeMode);
            $('#cbScheduleDateRangeMode').on('change', skyward.matrix.dateRangeMode);

            var body = $("body");
            body.off("browseLoaded." + availableCoursesBrowse).on("browseLoaded." + availableCoursesBrowse, function ()
            {
                $("#" + availableCoursesBrowse + "_seek").focus();
                $("#" + availableCoursesBrowse + "View").data("browseLoaded", true);
            });
            body.off("browseLoaded." + availableSectionsBrowse).on("browseLoaded." + availableSectionsBrowse, function ()
            {
                $("#" + availableSectionsBrowse + "_seek").focus();
                $("#" + availableSectionsView).data("browseLoaded", availableSectionsBrowse);
            });
            body.off("browseLoaded." + availableSectionsByRequestsAndOpenPeriodBrowse).on("browseLoaded." + availableSectionsByRequestsAndOpenPeriodBrowse, function ()
            {
                $("#" + availableSectionsByRequestsAndOpenPeriodBrowse + "_seek").focus();
                $("#" + availableSectionsView).data("browseLoaded", availableSectionsByRequestsAndOpenPeriodBrowse);
            });
            body.off("browseLoaded." + availableSectionsByOpenPeriodBrowse).on("browseLoaded." + availableSectionsByOpenPeriodBrowse, function ()
            {
                $("#" + availableSectionsByOpenPeriodBrowse + "_seek").focus();
                $("#" + availableSectionsView).data("browseLoaded", availableSectionsByOpenPeriodBrowse);
            });
            body.off("browseLoaded." + availableSectionsByChangeSectionBrowse).on("browseLoaded." + availableSectionsByChangeSectionBrowse, function ()
            {
                $("#" + availableSectionsByChangeSectionBrowse + "_seek").focus();
                $("#" + availableSectionsView).data("browseLoaded", availableSectionsByChangeSectionBrowse);
            });
            body.off("browseLoaded." + availableSectionsByOpenSectionsBrowse).on("browseLoaded." + availableSectionsByOpenSectionsBrowse, function ()
            {
                $("#" + availableSectionsByOpenSectionsBrowse + "_seek").focus();
                $("#" + availableSectionsByOpenSectionsBrowse + "View").data("browseLoaded", true);
            });
            body.off("browseLoaded." + availableSectionsByReplaceSectionBrowse).on("browseLoaded." + availableSectionsByReplaceSectionBrowse, function ()
            {
                $("#" + availableSectionsByReplaceSectionBrowse + "_seek").focus();
                $("#" + availableSectionsView).data("browseLoaded", availableSectionsByReplaceSectionBrowse);
            });

            //Toolbar button click events
            $(btnViewCourseBrowseID).off('click', skyward.matrix.updateAvailableCoursesPanel).on('click', skyward.matrix.updateAvailableCoursesPanel);
            $(btnCourseQuickEntryID).off('click', toggleQuickEntry).on('click', toggleQuickEntry);

            availableSectionsCancelButton = $('#btnBottomTabContainerCancelAction');
            availableSectionsCancelButton.off('click', cancelActions).on('click', cancelActions);

            //Quick Entry Panel events
            $(quickEntryToolbarAddCourseButtonID).off('click', addFromQuickEntry).on('click', addFromQuickEntry);
            $(quickEntryToolbarClearButtonID).off('click', clearQuickEntry).on('click', clearQuickEntry);
            $(quickEntryCourseEELID + "_value").off('change', updateAddCourseButton).on('change', updateAddCourseButton);

            //Primary Toolbar Button events
            $(btnSettingsID).off('click', showSettingsDialog).on('click', showSettingsDialog);
            $(btnScheduleBuilderLegendID).off('click', buildScheduleBuilderLegendPopup).on('click', buildScheduleBuilderLegendPopup);

            if (studentScheduleViewPart.data("viewmode") === "List" || studentScheduleViewPart.data("viewmode") === "Builder")
            {
                $(effectiveDatePickerID).off('change', skyward.matrix.effectiveDateChangeEventHandler);
                $(effectiveDatePickerID).on('change', skyward.matrix.effectiveDateChangeEventHandler);
            }
            if (studentScheduleViewPart.data("viewmode") === "WeeklySchedule" || studentScheduleViewPart.data("viewmode") === "Requests" || studentScheduleViewPart.data("viewmode") === "List" || studentScheduleViewPart.data("viewmode") === "Matrix")
            {
                $(cmbSpecifiedEntityID).off('change', changeSpecifiedEntityHandler).on('change', changeSpecifiedEntityHandler);
            }

            skyward.matrix.addEventListenerToDataMatrixCards();

            if (selector == actionMenuID)
            {
                actionsMenu = $(actionMenuID);
                actionsMenuDropButton = $("#" + actionsMenu.attr("id") + " #btnDropStudentSectionActionMenu");
                actionsMenuChangeButton = $("#" + actionsMenu.attr("id") + " #btnChangeStudentSectionActionMenu");
                actionsMenuReplaceButton = $("#" + actionsMenu.attr("id") + " #btnReplaceStudentSectionActionMenu");
                actionsMenuDeleteButton = $("#" + actionsMenu.attr("id") + " #btnDeleteStudentSection");
                actionsMenuEditButton = $("#" + actionsMenu.attr("id") + " #btnEditStudentSection");
                actionsMenuUnscheduleButton = $("#" + actionsMenu.attr("id") + " #btnUnscheduleStudentSection");
            }

            if (selector == "#" + studentCourseRequestBrowse)
            {
                setActiveStudentSectionOrRequest("", "");
                var browseSelector = $("#" + studentCourseRequestBrowse);
                browseSelector.off("rowChanged").on("rowChanged", function (event, browse)
                {
                    browseRowChanged(browse);
                });
                skyward.browse.registerDeselectPreviousRecordOverrideListener(studentCourseRequestBrowse, deselectPreviousRowOverride);
            }

            if (selector == "#" + availableSectionsView)
            {
                initializeBottomPanel();
                if (availableSectionsCancelButton.data("action") == undefined)
                {
                    availableSectionsCancelButton.data("action", "");
                }
            }

            //The course information may be filled in, so just refresh the buttons to make sure they have the right state
            updateAddCourseButton();
        };

        var initializeBottomPanel = function ()
        {
            var label = bottomTabContainer.find('.firstTab');
            label.addClass("current");

            bottomTabContainer.off("expandEvent", bottomTabBeginExpand).on("expandEvent", bottomTabBeginExpand);
            bottomTabContainer.off("collapseEvent", bottomTabCourseContainerCollapse).on("collapseEvent", bottomTabCourseContainerCollapse);
            bottomTabContainer.off("containerExpanded", bottomTabContainerExpanded).on("containerExpanded", bottomTabContainerExpanded);
            bottomTabContainer.off("containerCollapsed", bottomTabContainerCollapsed).on("containerCollapsed", bottomTabContainerCollapsed);

            bottomTabCourseContainer.off("collapseEvent", bottomTabContainerCollapse).on("collapseEvent", bottomTabContainerCollapse);
            bottomTabCourseContainer.off("containerExpanded", bottomTabCourseContainerExpanded).on("containerExpanded", bottomTabCourseContainerExpanded);

            var tabButtonList = bottomTabContainer.find(".tabStrip .tabButton");
            tabButtonList.each(function () 
            {
                $(this).off("tabClicked", bottomTabContainerTabClicked).on("tabClicked", bottomTabContainerTabClicked);
            });

            tabButtonList = bottomTabCourseContainer.find(".tabStrip .tabButton");
            tabButtonList.each(function ()
            {
                $(this).off("tabClicked", bottomTabCourseContainerTabClicked).on("tabClicked", bottomTabCourseContainerTabClicked);
            });

            bottomTabContainerSetDataProperties(false);
            bottomTabCourseContainerSetDataProperties(false, undefined);
        };

        var browseInitialLoad = true;
        var browseRowChanged = function (browse)
        {
            if (browse.browseName == studentCourseRequestBrowse)
            {
                if (browseInitialLoad)
                {
                    browseInitialLoad = false;
                }
                else
                {
                    deSelectSelectedCards();
                    var studentSectionIDs = browse.rowData['StudentSectionID'];
                    if (studentSectionIDs.length > 0 && browse.currentRow > -1 && browse.currentRow <= studentSectionIDs.length)
                    {
                        selectedCards(studentSectionIDs[browse.currentRow]);
                    }
                    $(".studentCourseRequest.selectedRow").removeClass("current");
                }
            }
        };

        var addCourseRequest = function (event)
        {
            var button = $(event.currentTarget);
            var courseID = button.data('courseid');
            var courseIDSecurityHash = button.data('courseid_securityhash');
            var entityID = studentScheduleViewPart.data("entityid");
            var entityIDSecurityHash = studentScheduleViewPart.data('entityid_securityhash');
            var studentID = button.data('studentid');
            var studentIDSecurityHash = button.data('studentid_securityhash');
            // Not all places are rendered server-side, with hashable values.  Eg. "Course" selector on quick entry toolbar.
            // At least it does not go into a workflow.  Are unsured ajax requests "better" anyway?
            skyward.matrix.addCourseRequest(courseID, entityID, entityIDSecurityHash, studentID, studentIDSecurityHash, courseIDSecurityHash);
        };

        skyward.matrix.addCourseRequest = function (courseID, entityID, entityIDSecurityHash, studentID, studentIDSecurityHash, courseIDSecurityHash)
        {
            var data = {
                EntityID: entityID,
                EntityID_SecurityHash: entityIDSecurityHash,
                StudentID: studentID,
                StudentID_SecurityHash: studentIDSecurityHash,
                CourseID: courseID
            };

            if (courseIDSecurityHash)
            {
                data["CourseID_SecurityHash"] = courseIDSecurityHash;
            }

            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/AddStudentCourseRequest",
                type: "POST",
                dataType: "JSON",
                data: data,
                success: function (data)
                {
                    if (data.success)
                    {
                        updateStudentRequests(data);
                    }
                    else
                    {
                        var errorList = $("<ul/>");

                        if (data.errors && $(data.errors).length > 0)
                        {
                            buildMessageBoxErrorList(errorList, data.errors);
                        }
                        else
                        {
                            buildMessageBoxErrorList(errorList, { "generic": ["A conflict was encountered."] });
                        }

                        var okButton = { text: "OK", "click": skyward.window.closePopup, "icon": "Check" };

                        var text = 'Unable to Add Student Course Request';
                        var message = $('<span/>')
                            .append($('<span>' + text + '</span>'))
                            .append(errorList);

                        skyward.window.closePopup();
                        skyward.modalLayer.showDialog("Unable to Add Student Course Requests", message, [okButton]);
                    }
                    clearQuickEntry();
                }
            });
        };

        skyward.matrix.updateBoard = function ()
        {
            if (availableSectionsCancelButton && availableSectionsCancelButton.data("action") == "")
            {
                toggleCancelButton(false);
            }

            allStudentScheduleViewParts.each(function ()
            {
                var thisItem = $(this);
                var postData =
                {
                    LowDate: thisItem.data('startdate'),
                    HighDate: thisItem.data('enddate'),
                    DisplayScheduleForDateRange: thisItem.data('displayschedulefordaterange'),
                    DisplayWeeklyScheduleFor: thisItem.data('displayweeklyschedulefor'),
                    StudentID: thisItem.data('studentid'),
                    studentid_securityhash: thisItem.data('studentid_securityhash'),
                    ViewMode: thisItem.data('viewmode'),
                    EffectiveDate: thisItem.data('effectivedate'),
                    UniqueID: thisItem.data('uniqueid'),
                    DateRangeMode: thisItem.data('daterangemode'),
                    EntityID: thisItem.data('entityid'),
                    entityid_securityhash: thisItem.data('entityid_securityhash'),
                    SchoolYearID: thisItem.data('schoolyearid'),
                    schoolyearid_securityhash: thisItem.data('schoolyearid_securityhash'),
                    WeeklyScheduleSelectedMonth: thisItem.data('weeklyscheduleselectedmonth'),
                    WeeklyScheduleSelectedWeek: thisItem.data('weeklyscheduleselectedweek')
                };

                var viewmode = thisItem.data('viewmode');
                if (AccessMode == "StudentAccess")
                {
                    viewmode = AccessMode;
                }

                if (viewmode == "StudentInformationPopup")
                {
                    var popupAccessMode = thisItem.parent().find("[name='accessmode']");
                    viewmode += skyward.controls.getValue(popupAccessMode);
                }

                $.ajax({
                    url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/UpdateScheduleMatrix" + viewmode,
                    type: "POST",
                    dataType: "viewparthtml",
                    data: postData,
                    success: function (htmlResponse)
                    {
                        var newHtml = $(htmlResponse);
                        var data = newHtml.data();
                        if (data["hasnoactivesections"])
                        {
                            cancelActions();
                            var okButton = { text: "OK", "click": skyward.window.closePopup, "icon": "Check" };
                            var title = 'Unable to Schedule Course';
                            var message = 'There are no active Sections of this Course available; the Student cannot be scheduled at this time.';
                            skyward.modalLayer.showDialog(title, message, [okButton]);
                        }
                        else
                        {
                            if (thisItem)
                            {
                                thisItem.html('');

                                if (newHtml.length > 0 && newHtml.children().length > 0)
                                {
                                    thisItem.append(newHtml.children());
                                    skyward.matrix.addEventListenerToDataMatrixCards();
                                }

                                skyward.window.notifyDOMLoad(outerMostContainerID); //added to keep datepicker control visible
                            }
                        }
                    }
                });
            });
        };

        skyward.matrix.updateCredits = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/GetUpdatedCredits",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    studentid: studentScheduleViewPart.data("studentid"),
                    studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                    entityID: studentScheduleViewPart.data("entityid"),
                    entityid_securityhash: studentScheduleViewPart.data('entityid_securityhash'),
                    schoolYearID: studentScheduleViewPart.data("schoolyearid"),
                    schoolyearid_securityhash: studentScheduleViewPart.data('schoolyearid_securityhash')
                },
                success: function (data)
                {
                    if (data.success)
                    {
                        updateStudentRequests(data);
                    }
                }
            });
        };

        skyward.matrix.updateAlternateRequests = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/GetUpdatedAlternateRequests",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    studentid: studentScheduleViewPart.data("studentid"),
                    studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                    entityID: studentScheduleViewPart.data("entityid"),
                    entityid_securityhash: studentScheduleViewPart.data('entityid_securityhash'),
                    schoolYearID: studentScheduleViewPart.data("schoolyearid"),
                    schoolyearid_securityhash: studentScheduleViewPart.data('schoolyearid_securityhash')
                },
                success: function (data)
                {
                    if (data.success)
                    {
                        if (data.AlternateRequests != "")
                        {
                            $(rightTabCourseRequestContainerID).find('.tabButton').eq(1).text("Alternate Requests (" + data.AlternateRequests + ")");
                        }
                        updateBrowseByName(studentCourseAlternateRequest, {});
                    }
                }
            });
        };

        skyward.matrix.updateScheduleListCredits = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/GetUpdatedCreditsTotalScheduleList",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    studentid: studentScheduleViewPart.data("studentid"),
                    studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                    entityID: studentScheduleViewPart.data("entityid"),
                    entityid_securityhash: studentScheduleViewPart.data('entityid_securityhash'),
                    schoolYearID: studentScheduleViewPart.data("schoolyearid"),
                    schoolyearid_securityhash: studentScheduleViewPart.data('schoolyearid_securityhash')
                },
                success: function (data)
                {
                    if (data.success)
                    {
                        if (data.ScheduledCredits != "")
                        {
                            $("#ScheduledCredits").val(data.ScheduledCredits);
                        }
                        if (data.TotalCredits != "")
                        {
                            $("#TotalCredits").val(data.TotalCredits);
                        }
                    }
                }
            });
        };

        skyward.matrix.updateCourseRequestsCredits = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/GetUpdatedCreditsTotalCourseRequests",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    studentid: studentScheduleViewPart.data("studentid"),
                    studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                    entityID: studentScheduleViewPart.data("entityid"),
                    entityid_securityhash: studentScheduleViewPart.data('entityid_securityhash'),
                    schoolYearID: studentScheduleViewPart.data("schoolyearid"),
                    schoolyearid_securityhash: studentScheduleViewPart.data('schoolyearid_securityhash')
                },
                success: function (data)
                {
                    if (data.success)
                    {
                        if (data.ScheduledCredits != "")
                        {
                            $("#ScheduledCredits").val(data.ScheduledCredits);
                        }
                        if (data.TotalCredits != "")
                        {
                            $("#TotalCredits").val(data.TotalCredits);
                        }
                    }
                }
            });
        };

        skyward.matrix.addStudentSectionFromScheduleListBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var data =
            {
                "Workflow.studentid": browseMenu.data("workflow.studentid"),
                "Workflow.studentid_securityhash": browseMenu.data("workflow.studentid_securityhash"),
                "Workflow.entityid": browseMenu.data("workflow.entityid"),
                "Workflow.entityid_securityhash": browseMenu.data("workflow.entityid_securityhash"),
                "Workflow.schoolyearid": browseMenu.data("workflow.schoolyearid"),
                "Workflow.schoolyearid_securityhash": browseMenu.data("workflow.schoolyearid_securityhash"),
                "Workflow.effectivedate": browseMenu.data("workflow.effectivedate")
            };
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/Add", null, data, null);
        };

        skyward.matrix.dropStudentSectionFromScheduleListBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var studentSectionID = browseMenu.data("workflow.studentsectionid");
            var effectiveDate = browseMenu.data("workflow.effectivedropdate");
            var browseName = browseMenu.data("workflow.:pagestatemodifycontrol");

            var data =
            {
                "Workflow.StudentSectionID": studentSectionID,
                "Workflow.entityid": browseMenu.data("workflow.entityid"),
                "Workflow.entityid_securityhash": browseMenu.data("workflow.entityid_securityhash"),
                "Workflow.EffectiveDropDate": effectiveDate,
                "Workflow.:PageStateModifyControl": browseName
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/Drop", null, data, null, skyward.matrix.updateScheduleListCredits);
        };

        skyward.matrix.unscheduleStudentSectionFromScheduleListBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var data =
            {
                "Workflow.studentsectionid": browseMenu.data("workflow.studentsectionid"),
                "Workflow.studentsectionid_securityhash": browseMenu.data("workflow.studentsectionid_securityhash"),
                "Workflow.entityid": browseMenu.data("workflow.entityid"),
                "Workflow.entityid_securityhash": browseMenu.data("workflow.entityid_securityhash"),
                "Workflow.:pagestatemodifycontrol": browseMenu.data("workflow.:pagestatemodifycontrol"),
                "Workflow.:pagestatemodifycontrol_securityhash": browseMenu.data("workflow.:pagestatemodifycontrol_securityhash")
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/UnscheduleStudentSection", null, data, null, skyward.matrix.updateScheduleListStudentRequestsAndCredits);
        };

        skyward.matrix.deleteStudentSectionFromScheduleListBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var studentSectionID = browseMenu.data("workflow.studentsectionid");
            var studentSectionID_securityhash = browseMenu.data("workflow.studentsectionid_securityhash");

            var data =
            {
                "Workflow.studentsectionid": studentSectionID,
                "Workflow.studentsectionid_securityhash": studentSectionID_securityhash,
                "Workflow.entityid": browseMenu.data("workflow.entityid"),
                "Workflow.entityid_securityhash": browseMenu.data("workflow.entityid_securityhash"),
                "Workflow.:pagestatemodifycontrol": browseMenu.data("workflow.:pagestatemodifycontrol"),
                "Workflow.:pagestatemodifycontrol_securityhash": browseMenu.data("workflow.:pagestatemodifycontrol_securityhash")
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/DeleteStudentSection", null, data, null, skyward.matrix.updateScheduleListStudentAlternatesAndCredits);
        };

        skyward.matrix.replaceStudentSectionFromScheduleListBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var studentSectionID = browseMenu.data("workflow.studentsectionid");
            var studentSectionID_securityhash = browseMenu.data("workflow.studentsectionid_securityhash");
            var effectiveDate = browseMenu.data("workflow.effectivedropdate");
            var browseName = browseMenu.data("workflow.:pagestatemodifycontrol");

            var data =
            {
                "Workflow.StudentSectionID": studentSectionID,
                "Workflow.studentsectionid_securityhash": studentSectionID_securityhash,
                "Workflow.entityid": browseMenu.data("workflow.entityid"),
                "Workflow.entityid_securityhash": browseMenu.data("workflow.entityid_securityhash"),
                "Workflow.EffectiveDropDate": effectiveDate,
                "Workflow.:PageStateModifyControl": browseName
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/Replace", null, data, null, skyward.matrix.updateScheduleListStudentRequestsAndCredits);
        };

        skyward.matrix.addStudentCourseRequestOrAlternatesFromScheduleListBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var data =
            {
                "Workflow.entityid": browseMenu.data("workflow.entityid"),
                "Workflow.entityid_securityhash": browseMenu.data("workflow.entityid_securityhash"),
                "Workflow.schoolyearid": browseMenu.data("workflow.schoolyearid"),
                "Workflow.schoolyearid_securityhash": browseMenu.data("workflow.schoolyearid_securityhash"),
                "Workflow.isalternate": browseMenu.data("workflow.isalternate"),
                "Workflow.isalternate_securityhash": browseMenu.data("workflow.isalternate_securityhash"),
                "Workflow.studentid": browseMenu.data("workflow.studentid"),
                "Workflow.studentid_securityhash": browseMenu.data("workflow.studentid_securityhash")
            };
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentCourseRequest/Add", null, data, null, skyward.matrix.updateScheduleListStudentRequestsAndCredits);
        };

        skyward.matrix.addStudentCourseRequestOrAlternatesFromScheduleRequestBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var data =
            {
                "Workflow.entityid": browseMenu.data("workflow.entityid"),
                "Workflow.entityid_securityhash": browseMenu.data("workflow.entityid_securityhash"),
                "Workflow.schoolyearid": browseMenu.data("workflow.schoolyearid"),
                "Workflow.schoolyearid_securityhash": browseMenu.data("workflow.schoolyearid_securityhash"),
                "Workflow.isalternate": browseMenu.data("workflow.isalternate"),
                "Workflow.isalternate_securityhash": browseMenu.data("workflow.isalternate_securityhash"),
                "Workflow.studentid": browseMenu.data("workflow.studentid"),
                "Workflow.studentid_securityhash": browseMenu.data("workflow.studentid_securityhash")
            };
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentCourseRequest/Add", null, data, null, skyward.matrix.updateStudentCourseRequests);
        };

        skyward.matrix.addStudentCourseRequestOrAlternatesFromScheduleBuilder = function (event)
        {
            var button = $(event.currentTarget);
            var data =
            {
                "Workflow.entityid": button.data("entityid"),
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": button.data("schoolyearid"),
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.isalternate": button.data("isalternate"),
                "Workflow.isalternate_securityhash": button.data("isalternate_securityhash"),
                "Workflow.studentid": button.data("studentid"),
                "Workflow.studentid_securityhash": button.data("studentid_securityhash")
            };
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentCourseRequest/Add", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.deleteStudentCourseRequestFromScheduleListBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var data =
            {
                "Workflow.studentcourserequestid": browseMenu.data("workflow.studentcourserequestid"),
                "Workflow.studentcourserequestid_securityhash": browseMenu.data("workflow.studentcourserequestid_securityhash")
            };
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentCourseRequest/DeleteStudentCourseRequest", null, data, null, skyward.matrix.updateScheduleListStudentRequestsAndCredits);
        };

        skyward.matrix.deleteStudentCourseRequestFromCourseRequestBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var data =
            {
                "Workflow.studentcourserequestid": browseMenu.data("workflow.studentcourserequestid"),
                "Workflow.studentcourserequestid_securityhash": browseMenu.data("workflow.studentcourserequestid_securityhash")
            };
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentCourseRequest/DeleteStudentCourseRequest", null, data, null, skyward.matrix.updateStudentCourseRequests);
        };

        var changeSpecifiedEntityHandler = function ()
        {
            var entitySelector = $(this)[0];
            var selectedIndex = entitySelector.selectedIndex;
            var selectedEntityID = entitySelector[selectedIndex].value;
            var selectedEntityIDHash;
            var selectentityidthenentityidhash = "";

            allStudentScheduleViewParts.each(function ()
            {
                selectentityidthenentityidhash = $(this).data('selectentityidthenentityidhash');
            });

            if (selectentityidthenentityidhash !== "")
            {
                $.each(selectentityidthenentityidhash, function (index, value)
                {
                    var keyValuePair = value.split("->");
                    var entityID = keyValuePair[0];
                    var entityIDHash = keyValuePair[1];

                    if (entityID === selectedEntityID)
                    {
                        selectedEntityIDHash = entityIDHash;
                    }
                });
            }

            studentScheduleViewPart.data('entityid', selectedEntityID);
            studentScheduleViewPart.data('entityid_securityhash', selectedEntityIDHash);

            var browse;
            var browseEntity;
            if (studentScheduleViewPart.data('viewmode') === "Requests")
            {
                browse = getBrowseByName("StudentCombineRequests");
                if (browse)
                {
                    browseEntity = browse.data["entityid"];

                    if (browseEntity !== selectedEntityID)
                    {
                        browse.data["entityid"] = selectedEntityID;
                    }

                    updateBrowseByName(studentCombineRequestScheduleListBrowse, {});
                }
            }
            else if (studentScheduleViewPart.data('viewmode') === "List")
            {
                // Top
                browse = getBrowseByName("StudentSections");
                if (browse)
                {
                    browseEntity = browse.data["entityid"];

                    if (browseEntity !== selectedEntityID)
                    {
                        browse.data["entityid"] = selectedEntityID;
                    }
                }

                // Bottom-Left
                browse = getBrowseByName("StudentCourseRequests");
                if (browse)
                {
                    browseEntity = browse.data["entityid"];

                    if (browseEntity !== selectedEntityID)
                    {
                        browse.data["entityid"] = selectedEntityID;
                    }
                }

                // Bottom-Right
                browse = getBrowseByName("StudentAlternateRequests");
                if (browse)
                {
                    browseEntity = browse.data["entityid"];

                    if (browseEntity !== selectedEntityID)
                    {
                        browse.data["entityid"] = selectedEntityID;
                    }
                }

                skyward.matrix.updateScheduleListPieces();
            }
            else
            {
                skyward.matrix.updateBoard();
            }
        };

        skyward.matrix.scheduleTypeEventHandler = function ()
        {
            var selectedFilter = $(this)[0];
            var index = selectedFilter.selectedIndex;
            var filterValues = selectedFilter[index].value;
            var values = filterValues.split('#');
            var lowDate = values[1];
            var highDate = values[2];

            studentScheduleViewPart.data('displayschedulefordaterange', filterValues);
            studentScheduleViewPart.data('startdate', lowDate);
            studentScheduleViewPart.data('enddate', highDate);

            if (studentScheduleViewPart.data('viewmode') === "List")
            {
                var browseId = "StudentSections";
                browse = getBrowseByName(browseId);
                var filter = browse.data['filter'];
                var filterJson = JSON.parse(filter);

                $.ajax(
                    {
                        url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/GenerateNewStudentScheduleListRouteHash",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            lowDate: lowDate,
                            highDate: highDate,
                            filter: JSON.stringify(filterJson),
                            DisplayScheduleForDateRange: filterValues
                        },
                        success: function (data)
                        {
                            if (data.RouteHash)
                            {
                                browse.routeHash = data.RouteHash;
                                browse.data['filter'] = data.Filter;
                                updateBrowseByName(browseId, browse.data);
                            }
                        }
                    });
            }
            else
            {
                skyward.matrix.updateBoard();
            }
        };

        skyward.matrix.weeklyScheduleMonthEventHandler = function () {
            var monthSelector = $('#cbMonthOfYear')[0];
            var selectedIndex = monthSelector.selectedIndex;
            var selectedMonthID = monthSelector[selectedIndex].value;

            var defaultWeekOfNewMonth = "";
            var weekOfYearSelector = $('#cbWeekOfYear');
            var currentSelectedWeekValue = weekOfYearSelector.val();
            var isValidWeek = false;

            weekOfYearSelector.find("option").each(function (weekID, weekElement) {
                var weekOfYearSelectorValue = weekElement.value;
                var values = weekOfYearSelectorValue.split('#');
                var monthIdOfWeek = values[0];

                if (monthIdOfWeek == selectedMonthID) {
                    skyward.controls.show(weekElement);

                    if (defaultWeekOfNewMonth === "") {
                        defaultWeekOfNewMonth = weekOfYearSelectorValue;
                    }

                    if (weekOfYearSelectorValue === currentSelectedWeekValue) {
                        isValidWeek = true;
                    }
                }
                else {
                    skyward.controls.hide(weekElement);
                }
            });

            var newSelectedWeek = defaultWeekOfNewMonth;

            if (isValidWeek) {
                newSelectedWeek = currentSelectedWeekValue;
            }

            weekOfYearSelector.val(newSelectedWeek);

            skyward.matrix.weeklyScheduleWeekEventHandler();
        };

        skyward.matrix.weeklyScheduleWeekEventHandler = function ()
        {
            var weekOfYearSelector = $('#cbWeekOfYear')[0];
            var weekSelectedIndex = weekOfYearSelector.selectedIndex;
            var weekOfYearSelectorValue = weekOfYearSelector[weekSelectedIndex].value;
            var values = weekOfYearSelectorValue.split('#');
            var selectedMonthOfYear = values[0];
            var selectedWeekOfYear = values[1];
            var lowDate = values[2];
            var highDate = values[3];

            if (AccessMode == "FamilyAccess" || AccessMode == "StudentAccess")
            {
                var postData = { DisplayWeeklyScheduleFor: weekOfYearSelectorValue };
                $.ajax({
                    url: skyward.global.virtualDir + "Scheduling/StudentScheduleDisplay/SaveSelectedWeekOfYearValue" + AccessMode,
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    success: function (data)
                    {
                        allStudentScheduleViewParts.each(function ()
                        {
                            $(this).data('displayweeklyschedulefor', weekOfYearSelectorValue);
                            $(this).data('startdate', lowDate);
                            $(this).data('enddate', highDate);
                        });

                        skyward.matrix.updateBoard();
                    }
                });
            }
            else
            {
                studentScheduleViewPart.data('displayweeklyschedulefor', weekOfYearSelectorValue);
                studentScheduleViewPart.data('startdate', lowDate);
                studentScheduleViewPart.data('enddate', highDate);

                skyward.matrix.updateBoard();
            }
        };

        skyward.matrix.effectiveDateChangeEventHandler = function ()
        {
            var previousValue = studentScheduleViewPart.data("effectivedate");
            var pickerDateText = this.value.split(" ")[0];
            var pickerDate = skyward.controls.getValue(this); // Without day of week.

            if (previousValue == pickerDateText)
            {
                return;
            }

            if (!skyward.datepicker.isValidDateObject(pickerDate))
            {
                showDatePickerError(previousValue, pickerDateText);
                return;
            }
            else
            {
                studentScheduleViewPart.data("effectivedate", pickerDateText);
            }

            switch (studentScheduleViewPart.data('viewmode'))
            {
                case "List":
                    changeBrowseVariables("StudentSections", "UpdateSessionVariableScheduleList", pickerDateText);
                    break;
                case "Builder":
                    updateSectionCodeEelParameterData(pickerDateText);
                    changeBrowseVariables("StudentCourseRequestBrowse", "UpdateSessionVariableScheduleBuilder", pickerDateText);
                    break;
            }
        };

        var changeBrowseVariables = function (browseId, action, effectiveDate)
        {
            if (browseId)
            {
                var browse = getBrowseByName(browseId);
                if (browse)
                {
                    var browseDate = browse.data["Workflow.effectivedate"];
                    if (browseDate != effectiveDate)
                    {
                        browse.data["Workflow.effectivedate"] = effectiveDate;
                        browse.queryParameterData.effectiveDate = effectiveDate;
                        updateBrowseByName(browseId, browse.data);
                    }
                }
            }
            if (action)
            {
                $.ajax({
                    url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/" + action,
                    type: "POST",
                    dataType: "JSON",
                    data: { effectiveDate: effectiveDate }
                });
            }
        };

        var updateSectionCodeEelParameterData = function (effectiveDate)
        {
            const effectiveDateName = "EffectiveDate";

            const sectionEEL = $(quickEntrySectionEELID);
            const codeEelQueryParameterData = skyward.codeeel.getQueryParameterData(sectionEEL);

            codeEelQueryParameterData[effectiveDateName] = effectiveDate;

            skyward.codeeel.setQueryParameterData(sectionEEL, codeEelQueryParameterData);
        }

        skyward.matrix.dateRangeMode = function ()
        {
            var dateRangeModeSelector = $('#cbScheduleDateRangeMode')[0];
            var dateRangeModeSelectedIndex = dateRangeModeSelector.selectedIndex;
            var selectedMode = dateRangeModeSelector[dateRangeModeSelectedIndex].value;

            var postData = { DateRangeMode: selectedMode };

            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentScheduleDisplay/SetDateRangeMode" + AccessMode,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    allStudentScheduleViewParts.each(function ()
                    {
                        $(this).data('daterangemode', selectedMode);
                    });

                    if (AccessMode == "FamilyAccess" || AccessMode == "StudentAccess")
                    {
                        var monthOfYearLabel = $('#lblMonthOfYear')[0];
                        var monthOfYearSelector = $('#cbMonthOfYear')[0];
                        var weekOfYearLabel = $('#lblWeekOfYear')[0];
                        var weekOfYearSelector = $('#cbWeekOfYear')[0];

                        if (monthOfYearLabel != null && monthOfYearSelector != null && weekOfYearLabel != null && weekOfYearSelector != null)
                        {
                            if (selectedMode == "WeeklySchedule")
                            {
                                monthOfYearLabel.style.display = "";
                                monthOfYearSelector.disabled = false;
                                monthOfYearSelector.style.display = "";
                                weekOfYearLabel.style.display = "";
                                weekOfYearSelector.disabled = false;
                                weekOfYearSelector.style.display = "";
                            }
                            else
                            {
                                monthOfYearLabel.style.display = "none";
                                monthOfYearSelector.style.display = "none";
                                weekOfYearLabel.style.display = "none";
                                weekOfYearSelector.style.display = "none";
                            }
                        }
                    }

                    skyward.matrix.updateBoard();
                }
            });
        };

        var getEffectiveDate = function ()
        {
            return skyward.time.parseDate(studentScheduleViewPart.data("effectivedate"));
        };

        var showDatePickerError = function (originalValue, proposedValue)
        {
            var message = '"' + proposedValue + '" could not be used as a date. The effective date will be changed back to ' + originalValue + '.';
            skyward.modalLayer.showDialog("Invalid Date.", message, undefined, { beforeClose: function () { skyward.controls.setValue($(effectiveDatePickerID), originalValue); } });
        };

        var updateStudentRequests = function (data)
        {
            if (data != null)
            {
                //Update the Credits section
                if (data.ElectiveCredits != "")
                {
                    $("#ElectiveCredits").val(data.ElectiveCredits);
                }

                if (data.RequiredCredits != "")
                {
                    $("#RequiredCredits").val(data.RequiredCredits);
                }

                if (data.TotalCredits != "")
                {
                    $("#TotalCredits").val(data.TotalCredits);
                }

                var browseData = {};
                if (data.StudentCourseRequestID)
                {
                    browseData.seekId = data.StudentCourseRequestID;
                }
                updateBrowseByName(studentCourseRequestBrowse, browseData);
            }
        };

        skyward.matrix.updateScheduleListPieces = function ()
        {
            skyward.matrix.updateScheduleListCredits();
            skyward.matrix.updateScheduleListAllBrowses();
        };

        skyward.matrix.updateScheduleListAllBrowses = function ()
        {
            skyward.matrix.updateScheduleListStudentSections();
            skyward.matrix.updateScheduleListStudentRequestsAndAlternates();
        };

        skyward.matrix.updateScheduleListStudentRequestsAndCredits = function ()
        {
            skyward.matrix.updateScheduleListCredits();
            skyward.matrix.updateScheduleListStudentRequestsAndAlternates();
        };

        skyward.matrix.updateStudentCourseRequests = function ()
        {
            skyward.matrix.updateCourseRequestsCredits();
            updateBrowseByName(studentCombineRequestScheduleListBrowse, {});
        };

        skyward.matrix.updateScheduleListStudentRequestsAndAlternates = function ()
        {
            updateBrowseByName(studentCourseRequestScheduleListBrowse, {});
            skyward.matrix.updateScheduleListAlternateRequests();
        };

        skyward.matrix.updateScheduleListStudentAlternatesAndCredits = function ()
        {
            skyward.matrix.updateScheduleListCredits();
            skyward.matrix.updateScheduleListAlternateRequests();
        };

        skyward.matrix.updateScheduleListAlternateRequests = function ()
        {
            updateBrowseByName(studentAlternateRequestScheduleListBrowse, {});
        };

        skyward.matrix.updateScheduleListStudentSections = function ()
        {
            updateBrowseByName(studentSectionScheduleListBrowse, {});
        };

        skyward.matrix.addStudentSectionFromSectionAddLink = function (event)
        {
            setAvailableSectionInfo(event);
            skyward.matrix.addStudentSectionWorkflow();
            event.stopPropagation ? event.stopPropagation() : (event.cancelBubble = true);
        };

        var setAvailableSectionInfo = function (event)
        {
            var cellID = event.currentTarget.id;
            var cellDiv;
            if (cellID.indexOf("Add") != -1)
            {
                cellID = cellID.replace("_Add", "");
                cellDiv = $("#" + cellID);
            }
            else
            {
                cellDiv = $(event.currentTarget);
            }

            studentScheduleViewPart.data('availablesectionsectionid', cellDiv.data("sectionid"));
            studentScheduleViewPart.data('availablesectionsectionid_securityhash', cellDiv.data("sectionid_securityhash"));
            studentScheduleViewPart.data('availablesectionstudentsectionsectionid_securityhash', cellDiv.data("studentsectionsectionid_securityhash"));
            studentScheduleViewPart.data('availablesectionstartdate', cellDiv.data("startdate"));
            studentScheduleViewPart.data('availablesectionenddate', cellDiv.data("enddate"));

            studentScheduleViewPart.data("availablesectioncourseinfo",
                {
                    courseCode: cellDiv.data("coursecode"),
                    courseDescription: cellDiv.data("coursedescription"),
                    sectionCode: cellDiv.data("sectioncode")
                });
        };

        var setAvailableSectionInfoFromBrowseMenu = function (sectionID, sectionID_securityhash, startDate, endDate, sectionBrowseName)
        {
            studentScheduleViewPart.data('availablesectionsectionid', sectionID);
            studentScheduleViewPart.data('availablesectionsectionid_securityhash', sectionID_securityhash);
            studentScheduleViewPart.data('availablesectionstudentsectionsectionid_securityhash', sectionID_securityhash);
            studentScheduleViewPart.data('availablesectionstartdate', startDate);
            studentScheduleViewPart.data('availablesectionenddate', endDate);

            var browse = getBrowseByName(sectionBrowseName);

            if (sectionBrowseName && browse)
            {
                var sectionRowIndex = $.inArray(parseInt(sectionID, 10), browse.primaryKeys);

                if (sectionRowIndex !== -1)
                {
                    if (browse && browse.rowData["Course.CourseCode"] && browse.rowData["Course.Description"] && browse.rowData["Code"])
                    {
                        studentScheduleViewPart.data("availablesectioncourseinfo",
                            {
                                courseCode: browse.rowData["Course.CourseCode"][sectionRowIndex],
                                courseDescription: browse.rowData["Course.Description"][sectionRowIndex],
                                sectionCode: browse.rowData["Code"][sectionRowIndex]
                            });
                    }
                }
                else
                {
                    studentScheduleViewPart.data("availablesectioncourseinfo",
                        {
                            courseCode: "",
                            courseDescription: "",
                            sectionCode: ""
                        });
                }
            }
            else
            {
                studentScheduleViewPart.data("availablesectioncourseinfo",
                    {
                        courseCode: "",
                        courseDescription: "",
                        sectionCode: ""
                    });
            }
        };

        skyward.matrix.addStudentSectionFromClassSummary = function ()
        {
            skyward.matrix.addStudentSectionWorkflow();
        };

        var addStudentSectionFromBrowseMenu = function ()
        {
            var data = $(this).data();
            var sectionID = data.sectionid;
            var sectionID_securityhash = data.sectionid_securityhash;
            var startDate = data.startdate;
            var endDate = data.enddate;
            var browseName = data.browsename;

            skyward.matrix.addStudentSectionFromBrowseMenu(sectionID, sectionID_securityhash, startDate, endDate, browseName);
        };

        skyward.matrix.addStudentSectionFromBrowseMenu = function (sectionID, sectionID_securityhash, startDate, endDate, sectionBrowseName)
        {
            setAvailableSectionInfoFromBrowseMenu(sectionID, sectionID_securityhash, startDate, endDate, sectionBrowseName);
            skyward.matrix.addStudentSectionWorkflow();
        };

        skyward.matrix.addStudentSectionWorkflow = function ()
        {
            studentScheduleViewPart.data("selectedStudentSection", studentScheduleViewPart.data("activeStudentSectionCard"));
            setStudentSectionInfo();

            var data =
            {
                "Workflow.effectivedate": studentScheduleViewPart.data("effectivedate"),
                "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                "Workflow.entityid_securityhash": studentScheduleViewPart.data("entityid_securityhash"),
                "Workflow.schoolyearid": studentScheduleViewPart.data("schoolyearid"),
                "Workflow.schoolyearid_securityhash": studentScheduleViewPart.data("schoolyearid_securityhash"),
                "Workflow.sectionid": studentScheduleViewPart.data('availablesectionsectionid'),
                "Workflow.sectionid_securityhash": studentScheduleViewPart.data('availablesectionsectionid_securityhash'),
                "Workflow.studentid": studentScheduleViewPart.data("studentid"),
                "Workflow.studentid_securityhash": studentScheduleViewPart.data("studentid_securityhash"),
                "Workflow.PageStateModifyControl": ""
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/Add", null, data, null);
        };

        skyward.matrix.addStudentSectionWorkflowClosed = function ()
        {
            skyward.matrix.reloadScheduleBuilderMatrixAndRequests();
            if (availableSectionsCancelButton.data("action") == "AddByCourse")
            {
                skyward.matrix.updateAvailableCoursesPanel();
            }
            else
            {
                collapseBottomPanels();
            }
        };

        skyward.matrix.updateAvailableCoursesPanel = function ()
        {
            toggleCancelButton(true, "AddByCourse");

            //if the schedule matrix is in a state with available sections, then it needs to be updated
            var scheduleMatrixCourseID = studentScheduleViewPart.data('courseid');
            if (scheduleMatrixCourseID != "" && scheduleMatrixCourseID != null)
            {
                skyward.matrix.updateBoard();
            }

            togglePanelToDisplay(bottomTabCourseContainer);

            setBottomTabCourseContainerCurrentTab();
        };

        var setBottomTabCourseContainerCurrentTab = function ()
        {
            var currentTab = undefined;

            var panelInfo = bottomTabCourseContainer.data("panelinfo");
            if (panelInfo != undefined && panelInfo.currentTab != undefined)
            {
                currentTab = panelInfo.currentTab;
            }

            if (currentTab == undefined)
            {
                bottomTabCourseContainerSetFirstTabCurrent();
                currentTab = bottomTabCourseContainer.find(".tabStrip .tabButton.firstTab");
            }

            // Sets tab text for "View Course List" Action
            $(bottomTabCourseContainerID).find('.tabButton').eq(0).text("Add By Course");
            $(bottomTabCourseContainerID).find('.tabButton').eq(1).text("Add By Sections");

            bottomTabCourseContainerSetDataProperties(true, currentTab);
            bottomTabCourseContainerExpand();
        };

        skyward.matrix.updateBottomTabContainerFromCourseBrowseMenu = function ()
        {
            var data = $(this).data();
            var courseID = data.courseid;
            var courseCode = data.courseCode;
            var courseDescription = data.courseDescription;

            studentScheduleViewPart.data("selectedStudentSection",
                {
                    courseid_securityhash: data.courseid_securityhash
                });
            setStudentSectionInfo();
            skyward.matrix.updateBottomTabContainerFromCourse("AddByCourseShowSections", courseID, courseCode, courseDescription);
        };

        skyward.matrix.updateBottomTabContainerFromRequestBrowseMenu = function ()
        {
            var data = $(this).data();
            var courseID = data.courseid;
            var courseCode = data.courseCode;
            var courseDescription = data.courseDescription;
            var studentCourseRequestID = data.studentcourserequestid;

            var studentSectionID = "";
            var rowIndex = getStudentCourseRequestRowIndex(studentCourseRequestID);

            if (rowIndex !== -1)
            {
                var browse = getBrowseByName(studentCourseRequestBrowse);
                studentSectionID = browse.rowData['StudentSectionID'][rowIndex];
            }

            studentScheduleViewPart.data("selectedStudentSection",
                {
                    studentsectionstartdate: "",
                    studentsectionenddate: "",
                    studentsectionid: studentSectionID,
                    studentsectionid_securityhash: "",
                    courseid: courseID,
                    courseid_securityhash: data.courseid_securityhash,
                    courseCode: courseCode,
                    courseDescription: courseDescription,
                    sectionCode: "",
                    sectionid: "",
                    sectionid_securityhash: "",
                    cellid: "",
                    studentsectiontransactionid: "",
                    studentsectiontransactionid_securityhash: "",
                    studentcourserequestid: studentCourseRequestID,
                    studentcourserequestid_securityhash: data.studentcourserequestid_securityhash,
                    countsforviewingentity: "",
                    hasatleastonetransactionnotcounttowardsviewingentity: "",
                    alltransactionscounttowardsviewingentity: "",
                    requestedfromofferingentityandalltransactionscounttowardsviewingentity: "",
                    requestedfromviewingentityandalltransactionscounttowardsviewingentity: "",
                    daterangescounttowardsviewingentity: ""
                });
            setStudentSectionInfo();

            activateSelectedRow(studentCourseRequestBrowse, studentCourseRequestID, studentSectionID);
            skyward.matrix.updateBottomTabContainerFromCourse("ScheduleCourse", courseID, courseCode, courseDescription, studentCourseRequestID);
        };

        skyward.matrix.updateAvailableSectionsOnBoard = function (courseID, studentCourseRequestID, changeSection, sectionID, courseCode, courseDescription)
        {
            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/UpdateScheduleMatrix" + studentScheduleViewPart.data('viewmode'),
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    StudentID: studentScheduleViewPart.data('studentid'),
                    studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                    LowDate: studentScheduleViewPart.data('startdate'),
                    HighDate: studentScheduleViewPart.data('enddate'),
                    ViewMode: studentScheduleViewPart.data('viewmode'),
                    DisplayScheduleForDateRange: studentScheduleViewPart.data('displayschedulefordaterange'),
                    DisplayWeeklyScheduleFor: studentScheduleViewPart.data('displayweeklyschedulefor'),
                    CourseID: courseID,
                    courseid_securityhash: studentScheduleViewPart.data('courseid_securityhash'),
                    ShowSections: true,
                    ChangeSection: changeSection,
                    SectionID: sectionID, //only applies to Change Section,
                    sectionid_securityhash: studentScheduleViewPart.data('sectionid_securityhash'),
                    effectivedate: studentScheduleViewPart.data("effectivedate"),
                    EntityID: studentScheduleViewPart.data('entityid'),
                    entityid_securityhash: studentScheduleViewPart.data('entityid_securityhash'),
                    SchoolYearID: studentScheduleViewPart.data('schoolyearid'),
                    schoolyearid_securityhash: studentScheduleViewPart.data('schoolyearid_securityhash'),
                    WeeklyScheduleSelectedMonth: studentScheduleViewPart.data('weeklyscheduleselectedmonth'),
                    WeeklyScheduleSelectedWeek: studentScheduleViewPart.data('weeklyscheduleselectedweek')
                },
                success: function (htmlResponse)
                {
                    var newHtml = $(htmlResponse);
                    var data = newHtml.data();
                    if (data["hasnoactivesections"])
                    {
                        cancelActions();
                        var okButton = { text: "OK", "click": skyward.window.closePopup, "icon": "Check" };
                        var title = 'Unable to Schedule Course';
                        var message;
                        if (changeSection)
                        {
                            message = 'There are no other active Sections of this Course available; the Student cannot change sections at this time.';
                        }
                        else
                        {
                            message = 'There are no active Sections of this Course available; the Student cannot be scheduled at this time.';
                        }
                        skyward.modalLayer.showDialog(title, message, [okButton]);
                    }
                    else
                    {
                        studentScheduleViewPart.html('');

                        if (newHtml.length > 0 && newHtml.children().length > 0)
                        {
                            studentScheduleViewPart.append(newHtml.children());
                        }

                        var numberAvailableSections = data["numberactivesections"];
                        var numberAvailableSectionsOpen = data["numberactivesectionsopen"];
                        if (numberAvailableSections != null && numberAvailableSections != "undefined" && numberAvailableSectionsOpen != null && numberAvailableSectionsOpen != "undefined")
                        {
                            var closedBrowseTitle = courseCode + " - " + courseDescription + " | " + numberAvailableSections + " Sections, " + numberAvailableSectionsOpen + " Open";
                            $(bottomTabContainerID).find('.firstTab').text(closedBrowseTitle);
                        }
                        studentScheduleViewPart.data('courseid', data["courseid"]);

                        selectStudentCourseListRow(studentCourseRequestID);

                        skyward.matrix.addEventListenerToDataMatrixCards();
                        skyward.matrix.addEventListenerToAvailableSectionCards();
                        skyward.window.notifyDOMLoad(outerMostContainerID); //added to keep datepicker control visible
                    }
                }
            });
        };

        skyward.matrix.updateBottomTabContainer = function (browseTitle, data)
        {
            loadBottomTabSectionsContainer(browseTitle, data);
            bottomTabContainerSetDataProperties(true);

            if (availableSectionsCancelButton.data("action") != undefined && availableSectionsCancelButton.data("action") != "ChangeSection" && availableSectionsCancelButton.data("action") != "ScheduleCourse")
            {
                bottomTabContainerExpand();
            }
            else
            {
                bottomTabContainerCollapse();
                togglePanelToDisplay(bottomTabContainer);
            }
        };

        var loadBottomTabSectionsContainer = function (browseTitle, data)
        {
            $(bottomTabContainerID).find('.firstTab').text(browseTitle);
            $("#" + availableSectionsView).data("browseLoaded", "");
            skyward.window.loadContent(availableSectionsView, 'Scheduling', 'StudentSchedule', 'GetAvailableBrowse', null, data, null, null, null, true);
        };

        skyward.matrix.updateBottomTabCourseContainer = function (firstTabBrowseTitle, secondTabBrowseTitle, data)
        {
            loadBottomTabSectionsCourseContainerFirstTab(firstTabBrowseTitle, data);
            loadBottomTabSectionsCourseContainerSecondTab(secondTabBrowseTitle, data);

            if (availableSectionsCancelButton.data("action") != undefined && availableSectionsCancelButton.data("action") != "ChangeSection" && availableSectionsCancelButton.data("action") != "ScheduleCourse")
            {
                togglePanelToDisplay(bottomTabCourseContainer);
                bottomTabCourseContainerExpand();
            }
            else
            {
                togglePanelToDisplay(bottomTabCourseContainer);
            }
        };

        var loadBottomTabSectionsCourseContainerFirstTab = function (browseTitle, data)
        {
            $(bottomTabCourseContainerID).find('.tabButton').eq(0).text(browseTitle);
            $("#" + availableCoursesBrowseView).data("browseLoaded", "");
            skyward.window.loadContent(availableCoursesBrowseView, 'Scheduling', 'StudentSchedule', 'GetAvailableSectionsByRequestsAndOpenPeriodBrowse', null, data, null, null, null, true);
        };

        var loadBottomTabSectionsCourseContainerSecondTab = function (browseTitle, data)
        {
            $(bottomTabCourseContainerID).find('.tabButton').eq(1).text(browseTitle);
            $("#" + availableSectionsByOpenSectionsBrowseView).data("browseLoaded", "");
            skyward.window.loadContent(availableSectionsByOpenSectionsBrowseView, 'Scheduling', 'StudentSchedule', 'GetAvailableSectionsByOpenPeriodBrowse', null, data, null, null, null, true);
        };

        skyward.matrix.updateBottomTabContainerFromCourse = function (action, courseID, courseCode, courseDescription, studentCourseRequestID, sectionID, changeSection)
        {
            var browseTitle = courseCode + " - " + courseDescription;
            var data = {
                studentid: studentScheduleViewPart.data('studentid'),
                studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                courseid: courseID,
                courseid_securityhash: studentScheduleViewPart.data('courseid_securityhash'),
                ChangeSection: changeSection,
                EffectiveDate: studentScheduleViewPart.data("effectivedate")
            };

            skyward.window.closePopup();
            toggleCancelButton(true, action);

            skyward.matrix.updateBottomTabContainer(browseTitle, data);
            skyward.matrix.updateAvailableSectionsOnBoard(courseID, studentCourseRequestID, changeSection, sectionID, courseCode, courseDescription);
        };

        skyward.matrix.updateAvailableSectionsOnBoardForReplace = function (courseID, studentCourseRequestID)
        {
            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/UpdateScheduleMatrix" + studentScheduleViewPart.data('viewmode'),
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    StudentID: studentScheduleViewPart.data('studentid'),
                    studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                    ViewMode: studentScheduleViewPart.data('viewmode'),
                    DisplayScheduleForDateRange: studentScheduleViewPart.data('displayschedulefordaterange'),
                    DisplayWeeklyScheduleFor: studentScheduleViewPart.data('displayweeklyschedulefor'),
                    CourseID: courseID,
                    courseid_securityhash: studentScheduleViewPart.data('courseid_securityhash'),
                    effectivedate: studentScheduleViewPart.data("effectivedate"),
                    EntityID: studentScheduleViewPart.data('entityid'),
                    entityid_securityhash: studentScheduleViewPart.data('entityid_securityhash'),
                    SchoolYearID: studentScheduleViewPart.data('schoolyearid'),
                    schoolyearid_securityhash: studentScheduleViewPart.data('schoolyearid_securityhash'),
                    WeeklyScheduleSelectedMonth: studentScheduleViewPart.data('weeklyscheduleselectedmonth'),
                    WeeklyScheduleSelectedWeek: studentScheduleViewPart.data('weeklyscheduleselectedweek')

                },
                success: function (htmlResponse)
                {
                    var newHtml = $(htmlResponse);
                    var data = newHtml.data();
                    if (data["hasnoactivesections"])
                    {
                        cancelActions();
                        var okButton = { text: "OK", "click": skyward.window.closePopup, "icon": "Check" };
                        var title = 'Unable to Schedule Course';
                        var message = 'There are no active Sections of this Course available; the Student cannot be scheduled at this time.';
                        skyward.modalLayer.showDialog(title, message, [okButton]);
                    }
                    else
                    {
                        studentScheduleViewPart.html('');

                        if (newHtml.length > 0 && newHtml.children().length > 0)
                        {
                            studentScheduleViewPart.append(newHtml.children());
                        }
                        studentScheduleViewPart.data('courseid', data["courseid"]);

                        selectStudentCourseListRow(studentCourseRequestID);

                        skyward.matrix.addEventListenerToDataMatrixCards();
                        skyward.window.notifyDOMLoad(outerMostContainerID); //added to keep datepicker control visible
                    }
                }
            });
        };

        skyward.matrix.updateBottomTabContainerFromReplace = function (action, courseID, courseIDSecurityHash, courseCode, sectionCode, courseDescription, studentCourseRequestID, sectionID, studentSectionID, studentSectionIDSecurityHash, replaceSection)
        {
            var browseTitle = "Replace " + courseDescription + " " + courseCode + "/" + sectionCode;
            var data = {
                CourseID: courseID,
                courseid_securityhash: courseIDSecurityHash,
                ReplaceSection: replaceSection,
                StudentSectionID: studentSectionID,
                studentsectionid_securityhash: studentSectionIDSecurityHash
            };

            skyward.window.closePopup();
            toggleCancelButton(true, action);

            skyward.matrix.updateBottomTabContainer(browseTitle, data);

            skyward.matrix.updateAvailableSectionsOnBoardForReplace(courseID, studentCourseRequestID);
        };

        skyward.matrix.updateBottomTabCourseContainerFromDisplayPeriod = function (event)
        {
            if (studentScheduleViewPart.data("viewmode") == "Builder")
            {
                var openCell = $(event.currentTarget);

                var courseRequestBrowseTitle = "Requested Courses - " + "Period " + openCell.data("displayperiodcode") + " Sections " + "(" + openCell.data("dayrotationcode") + ")";
                var allCoursesBrowseTitle = "All Courses - " + "Period " + openCell.data("displayperiodcode") + " Sections " + "(" + openCell.data("dayrotationcode") + ")";
                var data = {
                    studentid: studentScheduleViewPart.data('studentid'),
                    studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                    DisplayPeriodID: openCell.data("displayperiodid"),
                    displayperiodid_securityhash: openCell.data("displayperiodid_securityhash"),
                    StartDate: openCell.data("startdate"),
                    EndDate: openCell.data("enddate"),
                    EffectiveDate: studentScheduleViewPart.data("effectivedate")
                };

                var scheduleMatrixCourseID = studentScheduleViewPart.data('courseid');
                if (availableSectionsCancelButton && availableSectionsCancelButton.hasClass("matrixButtonEnable") || scheduleMatrixCourseID != "" || scheduleMatrixCourseID != null)
                {
                    deactivateSelectedRow(false);
                    toggleCancelButton(true, "AddSectionsByOpenPeriod");
                    skyward.matrix.updateBoard();
                }

                skyward.matrix.updateBottomTabCourseContainer(courseRequestBrowseTitle, allCoursesBrowseTitle, data);
                bottomTabCourseContainerSetFirstTabCurrent();
                var currentTab = bottomTabCourseContainer.find(".tabStrip .tabButton.firstTab");
                bottomTabCourseContainerSetDataProperties(true, currentTab);
                bottomTabCourseContainerExpand();
            }
        };

        skyward.matrix.reloadScheduleBuilderMatrixAndRequests = function ()
        {
            cancelActions();
            skyward.matrix.updateBoard();
            skyward.matrix.updateCredits();
            skyward.matrix.updateAlternateRequests();
        };

        var findCurrentTab = function (panelID)
        {
            if (panelID != undefined && panelID != "")
            {
                var currentTab = $(panelID).find('.tabButton.current');

                if (currentTab.length > 0)
                {
                    return currentTab;
                }
            }

            return undefined;
        };

        var findCurrentTabContent = function (currentTabIndex, panelID)
        {
            if (currentTabIndex != undefined && currentTabIndex > -1)
            {
                var tabContents = $(panelID).find('.tabContents');

                if (tabContents.length >= (currentTabIndex + 1))
                {
                    return $(tabContents[currentTabIndex]);
                }
            }

            return undefined;
        };

        var findCurrentTabContentContentContainer = function (tabContent)
        {
            if (tabContent != undefined && tabContent.length > 0)
            {
                var contentContainer = tabContent.children('.contentContainer');

                if (contentContainer.length > 0)
                {
                    return contentContainer;
                }
            }

            return undefined;
        };

        var findContentContainerFromCurrentTab = function (currentTab)
        {
            if (currentTab == undefined || !currentTab.length)
            {
                currentTab = findCurrentTab(bottomTabCourseContainerID);
            }

            if (currentTab == undefined || !currentTab.length || currentTab.data("index") == undefined || isNaN(currentTab.data("index")))
            {
                return { contentContainer: undefined };
            }

            var currentTabIndex = currentTab.data("index");
            var tabContent = findCurrentTabContent(currentTabIndex, bottomTabCourseContainerID);
            if (tabContent == undefined || !(tabContent.length > 0))
            {
                return { contentContainer: undefined };
            }

            var contentContainer = findCurrentTabContentContentContainer(tabContent);
            if (contentContainer == undefined || !(contentContainer.length > 0))
            {
                return { contentContainer: undefined };
            }

            var loadBrowse = false;
            if ((currentTab.data("refreshonclick") != undefined && currentTab.data("refreshonclick") == true) || contentContainer.data("browseLoaded") == undefined || contentContainer.data("browseLoaded") == false)
            {
                loadBrowse = true;
            }

            return { contentContainer: contentContainer, loadBrowse: loadBrowse };
        };

        var bottomTabContainerTabClicked = function ()
        {
            bottomTabContainerExpand();
            bottomTabContainerSearchBoxSetFocus();
        };

        var bottomTabContainerExpand = function ()
        {
            if (bottomTabContainer.hasClass("collapsed"))
            {
                $(bottomTabContainerID + 'ToggleButton').click();
            }
            else
            {
                bottomTabBeginExpand();
            }
        };

        var bottomTabBeginExpand = function ()
        {
            var bottomPanelAction = availableSectionsCancelButton.data("action");
            var displayPanel = bottomTabContainer.data("displayPanel");
            if ((bottomPanelAction != undefined && bottomPanelAction == "AddByCourseShowSections") || (displayPanel != undefined && displayPanel == true))
            {
                togglePanelToDisplay(bottomTabContainer);
                if (bottomTabContainer.hasClass("expanded"))
                {
                    var loadedBrowse = getbottomTabContainerLoadedBrowse();
                    if (loadedBrowse != "")
                    {
                        $("#" + loadedBrowse + "_seek").focus();
                    }
                }
            }
        };

        var bottomTabContainerExpanded = function ()
        {
            // maybe get rid of this
            bottomTabCourseContainerExpand();
            bottomTabContainerSearchBoxSetFocus();
        };

        var bottomTabContainerCollapse = function ()
        {
            if (!bottomTabContainer.hasClass("collapsed"))
            {
                $(bottomTabContainerID + 'ToggleButton').click();
            }
        };

        var bottomTabContainerCollapsed = function ()
        {
            //if not in AddByCourse Mode, then swap the panels
            var bottomPanelAction = availableSectionsCancelButton.data("action");
            if (bottomPanelAction == undefined || bottomPanelAction == "")
            {
                loadBottomTabSectionsContainer("", { CourseID: "-1", EffectiveDate: studentScheduleViewPart.data("effectivedate") });
                togglePanelToDisplay(bottomTabContainer);
            }
        };

        var bottomTabContainerSetDataProperties = function (displayPanel)
        {
            bottomTabContainer.data("displayPanel", displayPanel);
        };

        var bottomTabCourseContainerTabClicked = function ()
        {
            bottomTabCourseContainerSetDataProperties(true, $(this));
            bottomTabCourseContainerExpand();
        };

        var bottomTabCourseContainerExpand = function ()
        {
            if (bottomTabCourseContainer.hasClass("collapsed"))
            {
                $(bottomTabCourseContainerID + 'ToggleButton').click();
            }
            else
            {
                bottomTabCourseContainerBeginExpand();
            }
        };

        var bottomTabCourseContainerBeginExpand = function ()
        {
            var panelInfo = getBottomTabCourseContainerPanelInfo("displayPanelAndcurrentTab");
            var displayPanel = panelInfo.displayPanel;
            var currentTab = panelInfo.currentTab;
            var bottomPanelAction = availableSectionsCancelButton.data("action");

            if (bottomPanelAction != undefined && (bottomPanelAction == "AddByCourse" || bottomPanelAction == "AddSectionsByOpenPeriod") && displayPanel != undefined && displayPanel == true && currentTab != undefined && currentTab.length)
            {
                togglePanelToDisplay(bottomTabCourseContainer);

                if (bottomPanelAction == "AddByCourse")
                {
                    loadCourseTabContainer(currentTab);
                }

                if (bottomTabCourseContainer.hasClass("expanded"))
                {
                    bottomTabCourseContainerResizeAndSearchBoxSetFocus();
                }
            }
        };

        var bottomTabCourseContainerExpanded = function ()
        {
            bottomTabContainerExpand();

            var displayPanel = getBottomTabCourseContainerPanelInfo("currentTab");
            if (displayPanel.currentTab != undefined)
            {
                bottomTabCourseContainerSearchBoxSetFocus(displayPanel.currentTab);
            }
        };

        var bottomTabCourseContainerCollapse = function ()
        {
            if (bottomTabCourseContainer.hasClass("expanded"))
            {
                $(bottomTabCourseContainerID + 'ToggleButton').click();
            }
        };

        var bottomTabCourseContainerSetDataProperties = function (displayPanel, currentTab, forceClear)
        {
            if (currentTab || (forceClear != undefined && forceClear))
            {
                bottomTabCourseContainer.data("panelinfo",
                    {
                        "displayPanel": displayPanel,
                        "currentTab": currentTab
                    });
            }
        };

        var togglePanelToDisplay = function (panelToDisplay)
        {
            var bottomTabContainers = new Array(bottomTabCourseContainer, bottomTabContainer);

            for (var i = 0; i < bottomTabContainers.length; i++)
            {
                var current = bottomTabContainers[i];
                if (panelToDisplay && panelToDisplay == current)
                {
                    current.removeClass("behind").addClass("front");
                    current.css('display', 'block');
                }
                else
                {
                    current.removeClass("front").addClass("behind");
                    current.css('display', 'none');
                }
            }
        };

        var collapseBottomPanels = function ()
        {
            var action = availableSectionsCancelButton.data("action");
            if (action == "AddByCourseShowSections")
            {
                availableSectionsCancelButton.data("action", "");
                bottomTabContainerSetDataProperties(false);
                skyward.matrix.updateAvailableCoursesPanel();
            }
            else
            {
                toggleCancelButton(false);
                bottomTabContainerSetDataProperties(false);
                bottomTabCourseContainerSetDataProperties(false, undefined, true);
                bottomTabCourseContainerCollapse();

                if (bottomTabContainer.hasClass("collapsed"))
                {
                    bottomTabContainerCollapsed();
                }
            }
        };

        //JS Actions for Data Matrix Cards
        skyward.matrix.addEventListenerToDataMatrixCards = function ()
        {
            $('.matrixCell.dataMatrixCell').on("mouseover", toggleSelectStyle).on("mouseout", toggleSelectStyle);
        };

        var toggleSelectStyle = function (event)
        {
            var scheduledCardCell = $(this);

            //find all the cells of this section and highlight it
            $(".matrixCell.dataMatrixCell[data-studentsectionid=" + scheduledCardCell.data("studentsectionid") + "]").each(function ()
            {
                if (event.type == "mouseover")
                {
                    $(this).addClass('hover');
                }
                else
                {
                    $(this).removeClass('hover');
                }
            });
        };

        //JS Actions for Available Section Cards
        skyward.matrix.addEventListenerToAvailableSectionCards = function ()
        {
            $('.matrixCell.availableSection').on("mouseover", skyward.matrix.highlightMatchingSections).on("mouseout", skyward.matrix.highlightMatchingSections);
        };

        skyward.matrix.highlightMatchingSections = function (event)
        {
            var section = '[data-sectionid="' + $(this).data('sectionid') + '"]';
            if (event.type == "mouseover")
            {
                $(section).each(function ()
                {
                    $(this).addClass('hover');
                });
            }
            else
            {
                $(section).each(function ()
                {
                    $(this).removeClass('hover');
                });
            }
        };

        skyward.matrix.openClassSummaryPanel = function (event, action, data)
        {
            var promise = buildClassSummaryPanel(action, data);

            var getClassSummaryContent = function ()
            {
                var deferred = $.Deferred();

                $.when(promise).then(function (response)
                {
                    deferred.resolve(response.view);
                });

                return deferred.promise();
            };

            var getClassSummaryButtons = function ()
            {
                var deferred = $.Deferred();

                $.when(promise).then(function (response)
                {
                    if (studentScheduleViewPart.data("viewmode") === "Builder")
                    {
                        var effectiveDate = getEffectiveDate();
                        var selectedSection = $(studentScheduleViewPart).data("selectedStudentSection");
                        if (effectiveDate && selectedSection && selectedSection.studentsectionstartdate && selectedSection.studentsectionenddate)
                        {
                            var startDate = skyward.time.parseDate(selectedSection.studentsectionstartdate);
                            var endDate = skyward.time.parseDate(selectedSection.studentsectionenddate);
                            var isInProgress = effectiveDate >= startDate && effectiveDate <= endDate;
                            var daterangescounttowardsviewingentityValue = selectedSection.daterangescounttowardsviewingentity;

                            var isDroppable = false;
                            if (daterangescounttowardsviewingentityValue !== "")
                            {
                                $.each(daterangescounttowardsviewingentityValue, function (index, value)
                                {
                                    var range = value.replace("{", "").replace("}", "").split("->");
                                    var lowDate = skyward.time.parseDate(range[0]);
                                    var highDate = skyward.time.parseDate(range[1]);

                                    if (isInProgress && effectiveDate >= lowDate && effectiveDate <= highDate)
                                    {
                                        isDroppable = true;
                                    }
                                });
                            }

                            var highestIndex = response.buttons.length - 1;

                            for (var idx = highestIndex; idx >= 0; idx--)
                            {
                                var button = response.buttons[idx];

                                if (button.id === "btnUnscheduleStudentSection" && selectedSection.requestedfromviewingentityandalltransactionscounttowardsviewingentity.toLowerCase() === "false")
                                {
                                    response.buttons.splice(idx, 1);
                                }

                                if (button.id === "btnReplaceStudentSection" && selectedSection.requestedfromofferingentityandalltransactionscounttowardsviewingentity.toLowerCase() === "false")
                                {
                                    response.buttons.splice(idx, 1);
                                }

                                if (button.id === "btnEditStudentSection" && selectedSection.countsforviewingentity.toLowerCase() === "false")
                                {
                                    response.buttons.splice(idx, 1);
                                }

                                if (button.id === "btnDropStudentSection" && !isDroppable)
                                {
                                    response.buttons.splice(idx, 1);
                                }

                                if (button.id === "btnDeleteStudentSection" && selectedSection.alltransactionscounttowardsviewingentity.toLowerCase() === "false")
                                {
                                    response.buttons.splice(idx, 1);
                                }

                                if (button.id === "btnChangeStudentSection" && (effectiveDate > endDate || selectedSection.hasatleastonetransactionnotcounttowardsviewingentity.toLowerCase() === "true"))
                                {
                                    response.buttons.splice(idx, 1);
                                }
                            }
                        }
                    }

                    deferred.resolve(response.buttons);
                });

                return deferred.promise();
            };

            var options =
            {
                draggable: "true",
                width: 890,
                id: "classSummaryModal"
            };

            var getClassAndDescription = function ()
            {
                if ($(studentScheduleViewPart) !== null)
                {
                    if ($(studentScheduleViewPart).data("isscheduleblocker") !== undefined && $(studentScheduleViewPart).data("isscheduleblocker").toLowerCase() === "true")
                    {
                        return "Schedule Blocker Details";
                    }
                    else if (action.indexOf("GetStudentSectionClassSummaryPanel") !== -1 && $(studentScheduleViewPart).data("selectedStudentSection") !== null)
                    {   // Builder, Matrix, etc
                        if ($(studentScheduleViewPart).data("selectedStudentSection").courseDescription !== null)
                        {
                            return $(studentScheduleViewPart).data("selectedStudentSection").courseDescription
                                + ($(studentScheduleViewPart).data("selectedStudentSection").courseCode !== null ? " (" + $(studentScheduleViewPart).data("selectedStudentSection").courseCode + ")" : "")
                                + ($(studentScheduleViewPart).data("selectedStudentSection").sectionCode !== null ? " / " + $(studentScheduleViewPart).data("selectedStudentSection").sectionCode : "");
                        }
                    }
                    else if ($(studentScheduleViewPart).data("availablesectioncourseinfo") !== null)
                    {
                        if ($(studentScheduleViewPart).data("availablesectioncourseinfo").courseDescription !== null)
                        {
                            return $(studentScheduleViewPart).data("availablesectioncourseinfo").courseDescription
                                + ($(studentScheduleViewPart).data("availablesectioncourseinfo").courseCode !== null ? " (" + $(studentScheduleViewPart).data("availablesectioncourseinfo").courseCode + ")" : "")
                                + ($(studentScheduleViewPart).data("availablesectioncourseinfo").sectionCode !== null ? " / " + $(studentScheduleViewPart).data("availablesectioncourseinfo").sectionCode : "");
                        }
                    }
                }

                return undefined;
            };

            var classAndDescription = getClassAndDescription();

            skyward.modalLayer.showDialog(classAndDescription === undefined ? "Class Summary" : classAndDescription, getClassSummaryContent, getClassSummaryButtons, options);
        };

        var buildClassSummaryPanel = function (action, data)
        {
            return $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/" + action + "?renderType=contentOnly",
                type: "POST",
                dataType: "JSON",
                data: data
            });
        };

        skyward.matrix.openStudentSectionClassSummaryPanel = function (event)
        {
            // First try to find the nearest Student Schedule, in case there's more than one on screen from a popup or something
            var innerStudentScheduleViewPart = $(event.target).closest(".studentScheduleMatrix");

            // Didn't find anything, fall back to the global Student Schedule variable
            if (innerStudentScheduleViewPart.length === 0)
            {
                innerStudentScheduleViewPart = studentScheduleViewPart;
            }

            //close the actions menu
            if (innerStudentScheduleViewPart.parent().attr('id') != null &&
                innerStudentScheduleViewPart.parent().attr('id').toLowerCase() != 'studentinformationpopuptabpanel' &&
                innerStudentScheduleViewPart.parent().attr('id').toLowerCase().indexOf("studentinformationpopuptabcontainer") === -1)
            {
                skyward.window.closePopup();
            }

            var rawData = innerStudentScheduleViewPart.data();
            // copy data from innerStudentScheduleViewPart, skipping Objects and Arrays
            var data = Object.keys(rawData).reduce(function (result, key)
            {
                if (typeof (rawData[key]) !== "object")
                {
                    result[key] = rawData[key];
                }
                return result;
            }, {});
            // This key is specified manually since the data-attribute does not match what the server is expecting
            data["studentsectiontransaction"] = rawData["studentsectiontransactionid"];

            var viewmode = innerStudentScheduleViewPart.data("viewmode");
            var accessMode = innerStudentScheduleViewPart.parents(".studentInformationPopupTabPanel").find("[id$='accessmode']").val() || $("[id$='accessmode']").val();

            if (accessMode == "StudentAccess")
            {
                viewmode = "StudentAccess";
            }

            if (viewmode == "StudentInformationPopup")
            {
                viewmode = viewmode + accessMode;
            }

            skyward.matrix.openClassSummaryPanel(event, 'GetStudentSectionClassSummaryPanel' + viewmode, data);

            selectStudentCourseListRow(innerStudentScheduleViewPart.data("studentcourserequestid"), innerStudentScheduleViewPart.data("studentsectionid"));
            event.stopPropagation ? event.stopPropagation() : (event.cancelBubble = true);
        };

        skyward.matrix.openStudentSectionClassSummaryPanelFromCard = function (event)
        {
            // Arena Scheduling drop button on matrix was clicked, stop and let that event fire instead
            if (event.target.className && event.target.className.indexOf && event.target.className.indexOf("js-arenaScheduling-drop") > -1)
            {
                return;
            }

            var selectedStudentSection = setSelectedStudentSectionInfo(event);
            if (selectedStudentSection)
            {
                setStudentSectionInfo();
                skyward.matrix.openStudentSectionClassSummaryPanel(event);
            }
        };

        skyward.matrix.openStudentSectionClassSummaryPanelFromActionsMenu = function (event)
        {
            setStudentSectionInfo();
            skyward.matrix.openStudentSectionClassSummaryPanel(event);
        };

        skyward.matrix.openStudentSectionClassSummaryPanelFromProfilePopupGrades = function (event)
        {
            var source = $(event.target).closest('a');

            var data = {
                studentid: source.data("studentid"),
                studentid_securityhash: source.data("studentid_securityhash"),
                studentsectionid: source.data("studentsectionid"),
                studentsectiontransaction: source.data("studentsectiontransactionid"),
                studentsectiontransactionid_securityhash: source.data("studentsectiontransactionid_securityhash"),
                ViewMode: source.data("viewmode")
            };

            skyward.matrix.openClassSummaryPanel(event, 'GetStudentSectionClassSummaryPanel' + source.data("viewmode"), data);

            event.stopPropagation ? event.stopPropagation() : (event.cancelBubble = true);
        };

        var getStudentCourseRequestRowIndex = function (studentCourseRequestID)
        {
            var courseListRowIndex = -1;

            if (studentCourseRequestID != null && !isNaN(studentCourseRequestID) && studentCourseRequestID != 0 &&
                studentScheduleViewPart.data("viewmode") && studentScheduleViewPart.data("viewmode") == "Builder" &&
                getBrowseByName(studentCourseRequestBrowse))
            {
                courseListRowIndex = $.inArray(studentCourseRequestID.toString(), getBrowseByName(studentCourseRequestBrowse).rowData['StudentCourseRequestID']);
            }

            return courseListRowIndex;
        };

        var selectStudentCourseListRow = function (courseRequestID, studentSectionID)
        {
            var courseListRowIndex = getStudentCourseRequestRowIndex(courseRequestID);

            if (courseListRowIndex != -1)
            {
                var lockedRow = skyward.browse.getCurrentRowElement("locked", studentCourseRequestBrowse, courseListRowIndex);

                if (!lockedRow.hasClass("current"))
                {
                    skyward.browse.setCurrentRecord(studentCourseRequestBrowse, courseListRowIndex);
                }
            }

            deSelectSelectedCards();
            var browse = getBrowseByName(studentCourseRequestBrowse);
            if (courseListRowIndex !== -1 && (!studentSectionID || isNaN(studentSectionID)) && browse)
            {
                studentSectionID = browse.rowData['StudentSectionID'][courseListRowIndex];
            }

            if (studentSectionID && !isNaN(studentSectionID))
            {
                selectedCards(studentSectionID);
            }
        };

        skyward.matrix.openSectionClassSummaryPanel = function (event, sectionID, changeSection)
        {
            setAvailableSectionInfo(event);

            var data = {
                StudentID: studentScheduleViewPart.data("studentid"),
                studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                SectionID: sectionID,
                sectionid_securityhash: studentScheduleViewPart.data("availablesectionsectionid_securityhash"),
                ViewMode: studentScheduleViewPart.data("viewmode"),
                ChangeSection: changeSection,
                entityID: studentScheduleViewPart.data("entityid"),
                entityid_securityhash: studentScheduleViewPart.data('entityid_securityhash'),
                countsforviewingentity: studentScheduleViewPart.data('countsforviewingentity'),
                hasatleastonetransactionnotcounttowardsviewingentity: studentScheduleViewPart.data('hasatleastonetransactionnotcounttowardsviewingentity'),
                alltransactionscounttowardsviewingentity: studentScheduleViewPart.data('alltransactionscounttowardsviewingentity'),
                requestedfromofferingentityandalltransactionscounttowardsviewingentity: studentScheduleViewPart.data('requestedfromofferingentityandalltransactionscounttowardsviewingentity'),
                requestedfromviewingentityandalltransactionscounttowardsviewingentity: studentScheduleViewPart.data('requestedfromviewingentityandalltransactionscounttowardsviewingentity'),
                daterangescounttowardsviewingentity: studentScheduleViewPart.data('daterangescounttowardsviewingentity')
            };

            skyward.matrix.openClassSummaryPanel(event, 'GetSectionClassSummaryPanel', data);
        };

        var isTrueValue = function (value)
        {
            return value.toLowerCase() === "true";
        };

        var updateActionMenuButtonDisplay = function (button, display)
        {
            if (display)
            {
                button.css({ display: "" });
            }
            else
            {
                button.css({ display: "none" });
            }
        };

        skyward.matrix.openActionsPanel = function (event)
        {
            if (actionsMenu && actionsMenu.length)
            {
                if (actionsMenu.hasClass("hide"))
                {
                    deSelectSelectedCards();

                    var selectedStudentSection = setSelectedStudentSectionInfo(event);

                    var effectiveDate = getEffectiveDate();
                    var startDate = skyward.time.parseDate($(event.currentTarget).data('startdate'));
                    var endDate = skyward.time.parseDate($(event.currentTarget).data('enddate'));
                    var isInProgress = effectiveDate >= startDate && effectiveDate <= endDate;
                    var isBeforeOrIsInProgress = effectiveDate <= endDate;

                    var countsForViewingEntity = isTrueValue($(event.currentTarget).data('countsforviewingentity'));
                    var hasAtleastOneTransactionNotCountTowardsViewingEntity = isTrueValue($(event.currentTarget).data('hasatleastonetransactionnotcounttowardsviewingentity'));
                    var allTransactionsCountTowardsViewingEntity = isTrueValue($(event.currentTarget).data('alltransactionscounttowardsviewingentity'));
                    var requestedFromOfferingEntityAndAlltransactionsCountTowardsViewingEntity = isTrueValue($(event.currentTarget).data('requestedfromofferingentityandalltransactionscounttowardsviewingentity'));
                    var daterangescounttowardsviewingentityValue = $(event.currentTarget).data('daterangescounttowardsviewingentity');
                    var requestedfromviewingentityandalltransactionscounttowardsviewingentity = isTrueValue($(event.currentTarget).data('requestedfromviewingentityandalltransactionscounttowardsviewingentity'));

                    var isDroppable = false;
                    if (daterangescounttowardsviewingentityValue !== "")
                    {
                        $.each(daterangescounttowardsviewingentityValue, function (index, value)
                        {
                            var range = value.replace("{", "").replace("}", "").split("->");
                            var lowDate = skyward.time.parseDate(range[0]);
                            var highDate = skyward.time.parseDate(range[1]);

                            if (isInProgress && effectiveDate >= lowDate && effectiveDate <= highDate)
                            {
                                isDroppable = true;
                            }
                        });
                    }

                    updateActionMenuButtonDisplay(actionsMenuEditButton, countsForViewingEntity);

                    actionsMenuChangeButton.css({ display: (isBeforeOrIsInProgress && !hasAtleastOneTransactionNotCountTowardsViewingEntity) ? "" : "none" });
                    actionsMenuDeleteButton.css({ display: allTransactionsCountTowardsViewingEntity ? "" : "none" });
                    actionsMenuDropButton.css({ display: isDroppable ? "" : "none" });
                    actionsMenuEditButton.css({ display: countsForViewingEntity ? "" : "none" });
                    actionsMenuReplaceButton.css({ display: requestedFromOfferingEntityAndAlltransactionsCountTowardsViewingEntity ? "" : "none" });
                    actionsMenuUnscheduleButton.css({ display: requestedfromviewingentityandalltransactionscounttowardsviewingentity ? "" : "none" });

                    //need an element to be visible to get the height, so temp solution is to show the element behind the elements first
                    actionsMenu.css({ zIndex: -1 }).removeClass("hide").addClass("show");

                    var closeFunction = function ()
                    {
                        actionsMenu.addClass("hide").removeClass("show").css({ zIndex: -1 });
                    };

                    var options =
                    {
                        transparent: true,
                        beforeClose: closeFunction
                    };
                    selectStudentCourseListRow(selectedStudentSection.studentcourserequestid, selectedStudentSection.studentsectionid);
                    skyward.matrix.positionPopup(selectedStudentSection.cellid, actionsMenu, options);
                    event.stopPropagation ? event.stopPropagation() : (event.cancelBubble = true);
                }
            }
        };

        skyward.matrix.unscheduleStudentSectionFromBrowseMenu = function ()
        {
            var browseData = $(this).data();
            var studentSectionID = browseData.studentsectionid;
            var studentSectionID_securityhash = browseData.studentsectionid_securityhash;

            var data =
            {
                "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                "Workflow.entityid_securityhash": studentScheduleViewPart.data('entityid_securityhash'),
                "Workflow.studentsectionid": studentSectionID,
                "Workflow.studentsectionid_securityhash": studentSectionID_securityhash
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/UnscheduleStudentSection", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.unscheduleStudentSection = function ()
        {
            setStudentSectionInfo();
            var studentSectionID = studentScheduleViewPart.data("studentsectionid");

            var data =
            {
                "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                "Workflow.entityid_securityhash": studentScheduleViewPart.data('entityid_securityhash'),
                "Workflow.studentsectionid": studentSectionID,
                "Workflow.studentsectionid_securityhash": studentScheduleViewPart.data("studentsectionid_securityhash")
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/UnscheduleStudentSection", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.callIndividualStudentSchedulerFromScheduleList = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualStudentScheduler", null, data, null, skyward.matrix.updateScheduleListAllBrowses);
        };

        skyward.matrix.callIndividualStudyHallSchedulerFromScheduleList = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualStudyHallScheduler", null, data, null, skyward.matrix.updateScheduleListAllBrowses);
        };

        skyward.matrix.callReactivateStudentScheduleFromScheduleList = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/ReactivateStudentSchedule", null, data, null, skyward.matrix.updateScheduleListAllBrowses);
        };

        skyward.matrix.callReactivateStudentScheduleFromScheduleRequests = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/ReactivateStudentSchedule", null, data, null, skyward.matrix.updateScheduleListAllBrowses);
        };

        skyward.matrix.callIndividualStudentSchedulerFromScheduleBuilder = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualStudentScheduler", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.callIndividualStudyHallSchedulerFromScheduleBuilder = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualStudyHallScheduler", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.callReactivateStudentScheduleFromScheduleBuilder = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/ReactivateStudentSchedule", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.IndividualAddBySchedulingGroupFromScheduleList = function (event)
        {
            var button = $(event.currentTarget);

            var data =
            {
                "Workflow.entityid": button.data("entityid"),
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": button.data("schoolyearid"),
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": button.data("studentid"),
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualAddBySchedulingGroup", null, data, null, skyward.matrix.updateScheduleListAllBrowses);
        };

        skyward.matrix.IndividualAddBySchedulingGroupFromScheduleBuilder = function (event)
        {
            var button = $(event.currentTarget);

            var data =
            {
                "Workflow.entityid": button.data("entityid"),
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": button.data("schoolyearid"),
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": button.data("studentid"),
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualAddBySchedulingGroup", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.IndividualMassDropOrDeleteStudentScheduleFromScheduleList = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualMassDropOrDeleteStudentSchedule", null, data, null, skyward.matrix.updateScheduleListAllBrowses);
        };


        skyward.matrix.IndividualAddBySchedulingGroupFromScheduleRequests = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualAddBySchedulingGroup", null, data, null, skyward.matrix.updateStudentCourseRequests);
        };
        skyward.matrix.IndividualMassDropOrDeleteStudentScheduleFromScheduleBuilder = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualMassDropOrDeleteStudentSchedule", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.IndividualMassUnscheduleStudentSectionsFromScheduleList = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualMassUnscheduleStudentSections", null, data, null, skyward.matrix.updateScheduleListAllBrowses);
        };

        skyward.matrix.IndividualMassUnscheduleStudentSectionsFromScheduleBuilder = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualMassUnscheduleStudentSections", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.deleteStudentSection = function ()
        {
            var source = $(this);
            var studentSectionID = source.data("studentsectionid");
            var studentSectionID_securityhash = source.data("studentsectionid_securityhash");

            if (studentSectionID == undefined)
            {
                setStudentSectionInfo();
                studentSectionID = studentScheduleViewPart.data("studentsectionid");
                studentSectionID_securityhash = studentScheduleViewPart.data("studentsectionid_securityhash");
            }

            var data =
            {
                "Workflow.studentsectionid": studentSectionID,
                "Workflow.studentsectionid_securityhash": studentSectionID_securityhash,
                "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                "Workflow.entityid_securityhash": studentScheduleViewPart.data('entityid_securityhash')
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/DeleteStudentSection", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.deleteCourseRequestFromBrowseMenu = function ()
        {
            var data = $(this).data();
            var studentCourseRequestID = data.studentcourserequestid;

            var browseData =
            {
                "Workflow.studentcourserequestid": studentCourseRequestID,
                "Workflow.studentcourserequestid_securityhash": data.studentcourserequestid_securityhash
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentCourseRequest/DeleteStudentCourseRequest", null, browseData, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.positionPopup = function (offSetID, element, options)
        {
            var offsetElement = $('#' + offSetID);
            var buttons = BuildActionMenuButtons(element);
            skyward.modalLayer.showMenu(buttons, offsetElement, options);
        };

        var BuildActionMenuButtons = function (element)
        {
            var buttons = [];
            buttons.push({ type: 'title', text: 'Student Schedule Actions' });
            element.find('a').each(function ()
            {
                var renderedButton = $(this);

                var buttonObj =
                {
                    id: renderedButton.attr('id'),
                    click: renderedButton.attr('onclick'),
                    text: renderedButton.text(),
                    icon: renderedButton.data('icon')
                };
                if (renderedButton.css('display') != 'none')
                {
                    buttons.push(buttonObj);
                }
            });
            return buttons;
        };

        var deSelectSelectedCards = function ()
        {
            var isBuilder = (studentScheduleViewPart.data("viewmode") == "Builder");
            var activeStudentCourseRequestID;

            if (isBuilder)
            {
                activeStudentCourseRequestID = studentScheduleViewPart.data("activeStudentSectionOrRequest")["studentSectionID"];
            }

            if (previouslySelectStudentSectionID != "" && (!isBuilder || (activeStudentCourseRequestID != previouslySelectStudentSectionID)))
            {
                $("div[data-studentsectionid = " + previouslySelectStudentSectionID + "]").removeClass("selected");
                previouslySelectStudentSectionID = "";

                matrixBodyClickAdded = false;
                $("body").off("click", skywardMatrixBodyClick);
            }
        };

        var selectedCards = function (studentSectionID)
        {
            if (studentSectionID && studentSectionID != "")
            {
                var isBuilder = (studentScheduleViewPart.data("viewmode") == "Builder");
                var activeStudentCourseRequestID;

                if (isBuilder)
                {
                    activeStudentCourseRequestID = studentScheduleViewPart.data("activeStudentSectionOrRequest")["studentSectionID"];
                }

                var cellClass = "selected";
                if (isBuilder && activeStudentCourseRequestID != "" && activeStudentCourseRequestID == studentSectionID)
                {
                    cellClass += " active";
                }

                $("div.dataMatrixCell[data-studentsectionid =" + studentSectionID + "], div.dataMatrixCell[data-studentsectionid =" + studentSectionID + "] .matrixCellText").each(function ()
                {
                    $(this).addClass(cellClass);
                });

                previouslySelectStudentSectionID = studentSectionID;

                if (cellClass.indexOf("active") == -1 && !matrixBodyClickAdded)
                {
                    $("body").on("click", skywardMatrixBodyClick);
                    matrixBodyClickAdded = true;
                }
            }
        };

        var skywardMatrixBodyClick = function (event)
        {
            var runDeSelectSelectedCards = true;

            //There are two clicks - row click & body click
            if (preventDeselectTargetClick)
            {
                preventDeselectBodyClick = true;
                preventDeselectTargetClick = false;
            }

            var eventTarget = $(event.target);
            var eventTargetID = eventTarget.attr("id");

            //When clicking on the More Menu options on the Course List and clicking away (closing the glass) without actually selecting an item on the menu, want the selected cards to remain highlighted
            if (eventTargetID != undefined && eventTargetID.toLowerCase().indexOf(studentCourseRequestBrowse.toLowerCase() + "_rowmenu") != -1)
            {
                preventDeselectTargetClick = true;
            }
            else
            {
                eventTarget.parents("div .button").each(function ()
                {
                    if (this.id.toLowerCase().indexOf(studentCourseRequestBrowse.toLowerCase() + "_rowmenu") != -1)
                    {
                        preventDeselectTargetClick = true;
                    }
                });
            }

            //When clicking on the row of the Student Course List, the click event will bubble to the body click event, which will try to undo the selected cards, prevent this from happening
            eventTarget.parents("tr").each(function ()
            {
                if (this.id.toLowerCase().indexOf(studentCourseRequestBrowse.toLowerCase() + "_") != -1)
                {
                    runDeSelectSelectedCards = false;
                }
            });

            //When a glass is present, don't deselect the selected cards
            if ($("div.modalLayerContainer:last").length > 0 && !$('#studentInformationPopupTabPanel').length > 0)
            {
                runDeSelectSelectedCards = false;
            }

            if (preventDeselectBodyClick)
            {
                preventDeselectBodyClick = false;
                runDeSelectSelectedCards = false;
            }

            if (runDeSelectSelectedCards && previouslySelectStudentSectionID != "")
            {
                deSelectSelectedCards();
            }
        };

        skyward.matrix.updateAvailableSectionsFromChangeSection = function ()
        {
            setStudentSectionInfo();
            activateSelectedRow(studentCourseRequestBrowse, studentScheduleViewPart.data("studentcourserequestid"), studentScheduleViewPart.data("studentsectionid"));
            skyward.matrix.updateBottomTabContainerFromCourse(
                "ChangeSection",
                studentScheduleViewPart.data("courseid"),
                getCourseInfo("courseCode"),
                getCourseInfo("courseDescription"),
                studentScheduleViewPart.data("studentcourserequestid"),
                studentScheduleViewPart.data("sectionid"),
                true);
        };

        skyward.matrix.updateAvailableSectionsFromReplaceSection = function ()
        {
            setStudentSectionInfo();
            activateSelectedRow(studentCourseRequestBrowse, studentScheduleViewPart.data("studentcourserequestid"), studentScheduleViewPart.data("studentsectionid"));
            skyward.matrix.updateBottomTabContainerFromReplace(
                "ReplaceSection",
                studentScheduleViewPart.data("courseid"),
                studentScheduleViewPart.data("courseid_securityhash"),
                getCourseInfo("courseCode"),
                getCourseInfo("sectionCode"),
                getCourseInfo("courseDescription"),
                studentScheduleViewPart.data("studentcourserequestid"),
                studentScheduleViewPart.data("sectionid"),
                studentScheduleViewPart.data("studentsectionid"),
                studentScheduleViewPart.data("studentsectionid_securityhash"),
                true);
        };

        var getCourseInfo = function (infoToGet)
        {
            return findCourseInfo(infoToGet, "courseinfo");
        };

        var findCourseInfo = function (infoToGet, dataName)
        {
            var courseinfo = studentScheduleViewPart.data(dataName);

            switch (infoToGet)
            {
                case "courseCode":
                    if (courseinfo.courseCode)
                    {
                        return courseinfo.courseCode;
                    }
                    break;
                case "courseDescription":
                    if (courseinfo.courseDescription)
                    {
                        return courseinfo.courseDescription;
                    }
                    break;
                case "sectionCode":
                    if (courseinfo.sectionCode)
                    {
                        return courseinfo.sectionCode;
                    }
                    break;
                case "courseCodeDescriptionAndSection":
                    if (courseinfo.courseCode && courseinfo.courseDescription)
                    {
                        var courseCodeDescriptionAndSection = courseinfo.courseCode;
                        if (courseinfo.sectionCode && courseinfo.sectionCode != "")
                        {
                            courseCodeDescriptionAndSection += "/" + courseinfo.sectionCode;
                        }
                        courseCodeDescriptionAndSection += " - " + courseinfo.courseDescription;
                        return courseCodeDescriptionAndSection;
                    }
                    break;
                case "sectionOfCourseCodeDescription":
                    if (courseinfo.courseCode && courseinfo.courseDescription && courseinfo.sectionCode)
                    {
                        var sectionOfCourseCodeDescription = courseinfo.sectionCode + " of " + courseinfo.courseCode + " - " + courseinfo.courseDescription;
                        return sectionOfCourseCodeDescription;
                    }
                    break;
            }

            return "";
        };

        skyward.matrix.changeStudentSectionFromClassSummary = function ()
        {
            skyward.matrix.changeStudentSection(true);
        };

        skyward.matrix.changeStudentSectionFromChangeLink = function (event)
        {
            setAvailableSectionInfo(event);
            skyward.matrix.changeStudentSection(false);
            event.stopPropagation ? event.stopPropagation() : (event.cancelBubble = true);
        };

        skyward.matrix.changeStudentSectionFromBrowseMenu = function ()
        {
            var data = $(this).data();
            var sectionID = data.sectionid;
            var sectionID_securityhash = data.studentsectionsectionid_securityhash;
            var startDate = data.startdate;
            var endDate = data.enddate;

            var sectionBrowseName = "";
            if (getBrowseByName("AvailableSectionsByChangeSectionsBrowse"))
            {
                sectionBrowseName = 'AvailableSectionsByChangeSectionsBrowse';
            }

            setAvailableSectionInfoFromBrowseMenu(sectionID, sectionID_securityhash, startDate, endDate, sectionBrowseName);
            skyward.matrix.changeStudentSection(true);
        };

        skyward.matrix.changeStudentSection = function (closePopup)
        {
            var newSectionID = studentScheduleViewPart.data("availablesectionsectionid");
            var newStudentSectionSectionIDSecurityHash = studentScheduleViewPart.data("availablesectionstudentsectionsectionid_securityhash");

            studentScheduleViewPart.data("selectedStudentSection", studentScheduleViewPart.data("activeStudentSectionCard"));
            setStudentSectionInfo();

            var data =
            {
                "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                "Workflow.entityid_securityhash": studentScheduleViewPart.data('entityid_securityhash'),
                "Workflow.StudentSectionID": studentScheduleViewPart.data("studentsectionid"),
                "Workflow.studentsectionid_securityhash": studentScheduleViewPart.data("studentsectionid_securityhash"),
                "Workflow.EffectiveDateParam": studentScheduleViewPart.data("effectivedate"),
                "Workflow.studentsection.sectionid": newSectionID,
                "Workflow.studentsection.sectionid_securityhash": newStudentSectionSectionIDSecurityHash
            };
            if (closePopup)
            {
                skyward.window.closePopup();
            }
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/ChangeSection", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.changeStudentSectionFromScheduleListBrowseMenu = function ()
        {
            var thisData = $(this).data();
            var data =
            {
                "Workflow.:pagestatemodifycontrol": thisData["workflow.:pagestatemodifycontrol"],
                "Workflow.:pagestatemodifycontrol_securityhash": thisData["workflow.:pagestatemodifycontrol_securityhash"],
                "Workflow.entityid": thisData["workflow.entityid"],
                "Workflow.entityid_securityhash": thisData["workflow.entityid_securityhash"],
                "Workflow.StudentSectionID": thisData["workflow.studentsectionid"],
                "Workflow.studentsectionid_securityhash": thisData["workflow.studentsectionid_securityhash"],
                "Workflow.EffectiveDateParam": thisData["workflow.effectivedateparam"],
                "Workflow.EffectiveDateParam_securityhash": thisData["workflow.effectivedateparam_securityhash"]
            };
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/ChangeSection", null, data, null, skyward.matrix.updateScheduleListPieces);
        };

        var toggleCancelButton = function (enable, action)
        {
            if (action == undefined)
            {
                action = "";
            }

            if (enable)
            {
                availableSectionsCancelButton.data("action", action);
                availableSectionsCancelButton.removeClass("hidden");
            }
            else
            {
                availableSectionsCancelButton.data("action", "");
                availableSectionsCancelButton.addClass("hidden");
            }
        };

        var cancelActions = function ()
        {
            if (availableSectionsCancelButton && !availableSectionsCancelButton.hasClass('hidden'))
            {
                deactivateSelectedRow(false);
                collapseBottomPanels();
                skyward.matrix.updateBoard();
            }
        };

        skyward.matrix.updateAvailableSectionsFromChangeSectionBrowseMenu = function ()
        {
            var data = $(this).data();
            var courseID = data.courseid;
            var courseCode = data.courseCode;
            var courseDescription = data.courseDescription;
            var studentSectionID = data.studentsectionid;
            var sectionCode = data.sectionCode;
            var studentCourseRequestID = data.studentcourserequestid;
            var sectionID = data.sectionid;

            var studentSectionInfo = findStudentSectionInfoForCourseRequest(studentCourseRequestID);

            studentScheduleViewPart.data("selectedStudentSection",
                {
                    studentsectionstartdate: studentSectionInfo.studentsectionstartdate,
                    studentsectionenddate: studentSectionInfo.studentsectionenddate,
                    studentsectionid: studentSectionID,
                    studentsectionid_securityhash: data.studentsectionid_securityhash,
                    courseid: courseID,
                    courseid_securityhash: data.courseid_securityhash,
                    courseCode: courseCode,
                    courseDescription: courseDescription,
                    sectionCode: sectionCode,
                    sectionid: sectionID,
                    sectionid_securityhash: data.sectionid_securityhash,
                    cellid: "",
                    studentsectiontransactionid: "",
                    studentcourserequestid: studentCourseRequestID
                });
            setStudentSectionInfo();

            activateSelectedRow(studentCourseRequestBrowse, studentScheduleViewPart.data("studentcourserequestid"), studentScheduleViewPart.data("studentsectionid"));
            skyward.matrix.updateBottomTabContainerFromCourse(
                "ChangeSection",
                studentScheduleViewPart.data("courseid"),
                getCourseInfo("courseCode"),
                getCourseInfo("courseDescription"),
                studentScheduleViewPart.data("studentcourserequestid"),
                studentScheduleViewPart.data("sectionid"),
                true);
        };

        skyward.matrix.updateAvailableSectionsFromReplaceSectionBrowseMenu = function ()
        {
            var data = $(this).data();
            var courseID = data.courseid;
            var courseCode = data.courseCode;
            var courseDescription = data.courseDescription;
            var studentSectionID = data.originalstudentsectionid;
            var sectionCode = data.sectionCode;
            var studentCourseRequestID = data.studentcourserequestid;
            var sectionID = data.sectionid;

            var studentSectionInfo = findStudentSectionInfoForCourseRequest(studentCourseRequestID);

            studentScheduleViewPart.data("selectedStudentSection",
                {
                    studentsectionstartdate: studentSectionInfo.studentsectionstartdate,
                    studentsectionenddate: studentSectionInfo.studentsectionenddate,
                    studentsectionid: studentSectionID,
                    studentsectionid_securityhash: data.studentsectionid_securityhash,
                    courseid: courseID,
                    courseid_securityhash: data.courseid_securityhash,
                    courseCode: courseCode,
                    courseDescription: courseDescription,
                    sectionCode: sectionCode,
                    sectionid: sectionID,
                    sectionid_securityhash: data.sectionid_securityhash,
                    cellid: "",
                    studentsectiontransactionid: "",
                    studentsectiontransactionid_securityhash: "",
                    studentcourserequestid: studentCourseRequestID,
                    studentcourserequestid_securityhash: data.studentcourserequestid_securityhash
                });
            setStudentSectionInfo();

            checkUserSecurity("replaceSectionFromBrowseMenu");
        };

        var replaceSectionFromBrowseMenu = function (permissions)
        {
            if (permissions.allowUpdate || permissions.allowDelete)
            {
                activateSelectedRow(studentCourseRequestBrowse, studentScheduleViewPart.data("studentcourserequestid"), studentScheduleViewPart.data("studentsectionid"));
                skyward.matrix.updateBottomTabContainerFromReplace(
                    "ReplaceSection",
                    studentScheduleViewPart.data("courseid"),
                    studentScheduleViewPart.data("courseid_securityhash"),
                    getCourseInfo("courseCode"),
                    getCourseInfo("sectionCode"),
                    getCourseInfo("courseDescription"),
                    studentScheduleViewPart.data("studentcourserequestid"),
                    studentScheduleViewPart.data("sectionid"),
                    studentScheduleViewPart.data("studentsectionid"),
                    studentScheduleViewPart.data("studentsectionid_securityhash"),
                    true);
            }
            else
            {
                skyward.modalLayer.showCriticalDialog("Forbidden Access", "You do not have correct permissions to perform this task.");
            }
        };

        var checkUserSecurity = function (action)
        {
            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/CheckUserSecurity",
                type: "POST",
                dataType: "JSON",
                data: {},
                success: function (data)
                {
                    if (data && !$.isEmptyObject(data))
                    {
                        var permissions =
                        {
                            allowRead: data.PermissionRead === 'true',
                            allowCreate: data.PermissionCreate === 'true',
                            allowUpdate: data.PermissionUpdate === 'true',
                            allowDelete: data.PermissionDelete === 'true'
                        };

                        if (action == "dropStudentSectionfromBrowseMenu")
                        {
                            dropStudentSectionfromBrowseMenu(permissions);
                        }
                        else if (action == "replaceSectionFromBrowseMenu")
                        {
                            replaceSectionFromBrowseMenu(permissions);
                        }
                    }
                },
                error: function ()
                {
                    skyward.modalLayer.showCriticalDialog("Error", "Unable to check user security. The action could not be completed.");
                    return false;
                }
            });
        };

        var setSelectedStudentSectionInfo = function (event)
        {
            var cellDiv = $(event.currentTarget);

            if (cellDiv)
            {
                studentScheduleViewPart.data("selectedStudentSection",
                    {
                        studentsectionstartdate: cellDiv.data("startdate"),
                        studentsectionenddate: cellDiv.data("enddate"),
                        calendarday: cellDiv.data("calendarday"),
                        studentsectionid: cellDiv.data("studentsectionid"),
                        studentsectionid_securityhash: cellDiv.data("studentsectionid_securityhash"),
                        courseid: cellDiv.data("courseid"),
                        courseid_securityhash: cellDiv.data("courseid_securityhash"),
                        courseCode: cellDiv.data("coursecode"),
                        courseDescription: cellDiv.data("coursedescription"),
                        sectionCode: cellDiv.data("sectioncode"),
                        sectionid: cellDiv.data("sectionid"),
                        sectionid_securityhash: cellDiv.data("sectionid_securityhash"),
                        cellid: cellDiv.data("cellid"),
                        studentsectiontransactionid: cellDiv.data("studentsectiontransactionid"),
                        studentsectiontransactionid_securityhash: cellDiv.data("studentsectiontransactionid_securityhash"),
                        studentcourserequestid: cellDiv.data("studentcourserequestid"),
                        studentcourserequestid_securityhash: cellDiv.data("studentcourserequestid_securityhash"),
                        meetid: cellDiv.data("meetid"),
                        meetid_securityhash: cellDiv.data("meetid_securityhash"),
                        displayperiodid: cellDiv.data("displayperiodid"),
                        displayperiodid_securityhash: cellDiv.data("displayperiodid_securityhash"),
                        isscheduleblocker: cellDiv.data("isscheduleblocker"),
                        countsforviewingentity: cellDiv.data("countsforviewingentity"),
                        hasatleastonetransactionnotcounttowardsviewingentity: cellDiv.data("hasatleastonetransactionnotcounttowardsviewingentity"),
                        alltransactionscounttowardsviewingentity: cellDiv.data("alltransactionscounttowardsviewingentity"),
                        requestedfromofferingentityandalltransactionscounttowardsviewingentity: cellDiv.data("requestedfromofferingentityandalltransactionscounttowardsviewingentity"),
                        requestedfromviewingentityandalltransactionscounttowardsviewingentity: cellDiv.data("requestedfromviewingentityandalltransactionscounttowardsviewingentity"),
                        daterangescounttowardsviewingentity: cellDiv.data("daterangescounttowardsviewingentity")
                    });
            }
            else
            {
                studentScheduleViewPart.data("selectedStudentSection",
                    {
                        studentsectionstartdate: "",
                        studentsectionenddate: "",
                        calendarday: "",
                        studentsectionid: "",
                        studentsectionid_securityhash: "",
                        courseid: "",
                        courseid_securityhash: "",
                        courseCode: "",
                        courseDescription: "",
                        sectionCode: "",
                        sectionid: "",
                        sectionid_securityhash: "",
                        cellid: "",
                        studentsectiontransactionid: "",
                        studentsectiontransactionid_securityhash: "",
                        studentcourserequestid: "",
                        studentcourserequestid_securityhash: "",
                        meetid: "",
                        meetid_securityhash: "",
                        displayperiodid: "",
                        displayperiodid_securityhash: "",
                        isscheduleblocker: "false",
                        countsforviewingentity: "",
                        hasatleastonetransactionnotcounttowardsviewingentity: "",
                        alltransactionscounttowardsviewingentity: "",
                        requestedfromofferingentityandalltransactionscounttowardsviewingentity: "",
                        requestedfromviewingentityandalltransactionscounttowardsviewingentity: "",
                        daterangescounttowardsviewingentity: ""
                    });
            }

            return studentScheduleViewPart.data("selectedStudentSection");
        };

        var setStudentSectionInfo = function ()
        {
            var selectedStudentSection = studentScheduleViewPart.data("selectedStudentSection");

            if (selectedStudentSection)
            {
                studentScheduleViewPart.data("studentsectionstartdate", selectedStudentSection.studentsectionstartdate);
                studentScheduleViewPart.data("studentsectionenddate", selectedStudentSection.studentsectionenddate);
                studentScheduleViewPart.data("calendarday", selectedStudentSection.calendarday);
                studentScheduleViewPart.data("studentsectionid", selectedStudentSection.studentsectionid);
                studentScheduleViewPart.data("studentsectionid_securityhash", selectedStudentSection.studentsectionid_securityhash);
                studentScheduleViewPart.data("courseid", selectedStudentSection.courseid);
                studentScheduleViewPart.data("courseid_securityhash", selectedStudentSection.courseid_securityhash);
                studentScheduleViewPart.data("courseinfo",
                    {
                        courseCode: selectedStudentSection.courseCode,
                        courseDescription: selectedStudentSection.courseDescription,
                        sectionCode: selectedStudentSection.sectionCode
                    }
                );
                studentScheduleViewPart.data("sectionid", selectedStudentSection.sectionid);
                studentScheduleViewPart.data("sectionid_securityhash", selectedStudentSection.sectionid_securityhash);
                studentScheduleViewPart.data("cellid", selectedStudentSection.cellid);
                studentScheduleViewPart.data("studentsectiontransactionid", selectedStudentSection.studentsectiontransactionid);
                studentScheduleViewPart.data("studentsectiontransactionid_securityhash", selectedStudentSection.studentsectiontransactionid_securityhash);
                studentScheduleViewPart.data("studentcourserequestid", selectedStudentSection.studentcourserequestid);
                studentScheduleViewPart.data("studentcourserequestid_securityhash", selectedStudentSection.studentcourserequestid_securityhash);
                studentScheduleViewPart.data("meetid", selectedStudentSection.meetid);
                studentScheduleViewPart.data("meetid_securityhash", selectedStudentSection.meetid_securityhash);
                studentScheduleViewPart.data("displayperiodid", selectedStudentSection.displayperiodid);
                studentScheduleViewPart.data("displayperiodid_securityhash", selectedStudentSection.displayperiodid_securityhash);
                studentScheduleViewPart.data("isscheduleblocker", selectedStudentSection.isscheduleblocker);
                studentScheduleViewPart.data("countsforviewingentity", selectedStudentSection.countsforviewingentity);
                studentScheduleViewPart.data("hasatleastonetransactionnotcounttowardsviewingentity", selectedStudentSection.hasatleastonetransactionnotcounttowardsviewingentity);
                studentScheduleViewPart.data("alltransactionscounttowardsviewingentity", selectedStudentSection.alltransactionscounttowardsviewingentity);
                studentScheduleViewPart.data("requestedfromofferingentityandalltransactionscounttowardsviewingentity", selectedStudentSection.requestedfromofferingentityandalltransactionscounttowardsviewingentity);
                studentScheduleViewPart.data("requestedfromviewingentityandalltransactionscounttowardsviewingentity", selectedStudentSection.requestedfromviewingentityandalltransactionscounttowardsviewingentity);
                studentScheduleViewPart.data("daterangescounttowardsviewingentity", selectedStudentSection.daterangescounttowardsviewingentity);
            }
        };

        var getBrowseByName = function (name)
        {
            var browse = skyward.browse.browseList[name];
            if (browse === undefined)
            {
                browse = skyward.browse.browseList["detailsPanel_" + name];
            }
            return browse;
        };

        var updateBrowseByName = function (name, data)
        {
            var browse = skyward.browse.get(name, data);
            if (browse === null)
            {
                browse = skyward.browse.get("detailsPanel_" + name, data);
            }
            return browse;
        };

        var findStudentSectionInfoForCourseRequest = function (studentCourseRequestID)
        {
            //in progress transaction or earliest min date and max date
            var effectiveDate = getEffectiveDate();
            var minStartDate = null;
            var maxStartDate = null;
            var startDate = null;
            var endDate = null;

            $("div.dataMatrixCell[data-studentcourserequestid =" + studentCourseRequestID + "]").each(function ()
            {
                var relatedCell = $(this);
                var cellStartDate = skyward.time.parseDate(relatedCell.data("startdate"));
                var cellEndDate = skyward.time.parseDate(relatedCell.data("enddate"));

                if (cellStartDate <= effectiveDate && cellEndDate >= effectiveDate)
                {
                    startDate = cellStartDate;
                    endDate = cellEndDate;
                }

                if (minStartDate == null)
                {
                    minStartDate = cellStartDate;
                }
                else if (cellStartDate < minStartDate)
                {
                    minStartDate = cellStartDate;
                }

                if (maxStartDate == null)
                {
                    maxStartDate = cellEndDate;
                }
                else if (cellEndDate > maxStartDate)
                {
                    maxStartDate = maxStartDate;
                }
            });

            if (startDate == null)
            {
                startDate = minStartDate;
            }

            if (endDate == null)
            {
                endDate = maxStartDate;
            }

            return { studentsectionstartdate: startDate, studentsectionenddate: endDate };
        };

        skyward.matrix.dropStudentSectionfromBrowseMenu = function ()
        {
            var studentCourseRequestID = $(this).data('studentcourserequestid');
            var studentSectionInfo = findStudentSectionInfoForCourseRequest(studentCourseRequestID);
            var courseListRowIndex = getStudentCourseRequestRowIndex(studentCourseRequestID);

            if (courseListRowIndex != -1)
            {
                var rowData = getBrowseByName(studentCourseRequestBrowse).rowData;

                studentScheduleViewPart.data("selectedStudentSection",
                    {
                        studentsectionstartdate: studentSectionInfo.studentsectionstartdate,
                        studentsectionenddate: studentSectionInfo.studentsectionenddate,
                        studentsectionid: $(this).data('studentsectionid'),
                        studentsectionid_securityhash: $(this).data('studentsectionid_securityhash'),
                        courseid: "",
                        courseid_securityhash: "",
                        courseCode: rowData['StudentSection.Section.Course.CourseCode'][courseListRowIndex],
                        courseDescription: rowData['StudentSection.Section.Course.Description'][courseListRowIndex],
                        sectionCode: rowData['StudentSection.Section.Code'][courseListRowIndex],
                        sectionid: "",
                        sectionid_securityhash: "",
                        cellid: "",
                        studentsectiontransactionid: "",
                        studentsectiontransactionid_securityhash: "",
                        studentcourserequestid: studentCourseRequestID,
                        studentcourserequestid_securityhash: $(this).data('studentcourserequestid_securityhash'),
                        countsforviewingentity: "",
                        hasatleastonetransactionnotcounttowardsviewingentity: "",
                        alltransactionscounttowardsviewingentity: "",
                        requestedfromofferingentityandalltransactionscounttowardsviewingentity: "",
                        requestedfromviewingentityandalltransactionscounttowardsviewingentity: "",
                        daterangescounttowardsviewingentity: ""
                    });
                setStudentSectionInfo();

                checkUserSecurity("dropStudentSectionfromBrowseMenu");
            }
            else
            {
                skyward.modalLayer.showCriticalDialog("Forbidden Access", "You do not have correct permissions to perform this task.");
            }
        };

        var dropStudentSectionfromBrowseMenu = function (permissions)
        {
            if (permissions.allowUpdate)
            {
                skyward.matrix.dropStudentSectionWorkflow();
            }
            else
            {
                skyward.modalLayer.showCriticalDialog("Forbidden Access", "You do not have correct permissions to perform this task.");
            }
        };

        skyward.matrix.dropStudentSectionfromActionsMenu = function ()
        {
            setStudentSectionInfo();
            skyward.matrix.dropStudentSectionWorkflow();
        };

        skyward.matrix.dropStudentSectionWorkflow = function ()
        {
            if (validateStudentSectionTransactionEndDate("drop"))
            {
                var data =
                {
                    "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                    "Workflow.entityid_securityhash": studentScheduleViewPart.data('entityid_securityhash'),
                    "Workflow.StudentSectionID": studentScheduleViewPart.data("studentsectionid"),
                    "Workflow.EffectiveDropDate": studentScheduleViewPart.data("effectivedate")
                };
                skyward.window.closePopup();
                skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/Drop", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
            }
        };

        skyward.matrix.replaceStudentSectionWorkflow = function ()
        {
            var browseData = $(this).data();
            var originalStudentSectionID = browseData.studentsectionid;
            var proposedSectionID = browseData.sectionid;

            var data =
            {
                "Workflow.StudentSectionID": originalStudentSectionID,
                "Workflow.studentsectionid_securityhash": browseData.studentsectionid_securityhash,
                "Workflow.StudentSection.SectionID": proposedSectionID,
                "Workflow.studentsection.sectionid_securityhash": browseData.studentsectionsectionid_securityhash,
                "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                "Workflow.entityid_securityhash": studentScheduleViewPart.data('entityid_securityhash'),
                "Workflow.EffectiveDropDate": studentScheduleViewPart.data("effectivedate"),
                "Workflow.PageStateModifyControl": ""
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/Replace", null, data, null, skyward.matrix.replaceStudentSectionWorkflowClosed);
        };

        skyward.matrix.replaceStudentSectionWorkflowClosed = function ()
        {
            skyward.matrix.reloadScheduleBuilderMatrixAndRequests();
            collapseBottomPanels();
        };

        skyward.matrix.editStudentSection = function ()
        {
            var studentSectionID = $(this).data("studentsectionid");
            var studentSectionIDHash = $(this).data("studentsectionid_securityhash");
            var studentSectionTransactionID = $(this).data("studentsectiontransactionid");
            var studentSectionTransactionIDHash = $(this).data("studentsectiontransactionid_securityhash");
            var effectiveDate = studentScheduleViewPart.data("effectivedate");

            if (studentSectionID == undefined)
            {
                setStudentSectionInfo();
                studentSectionID = studentScheduleViewPart.data("studentsectionid");
                studentSectionIDHash = studentScheduleViewPart.data("studentsectionid_securityhash");
                studentSectionTransactionID = studentScheduleViewPart.data("studentsectiontransactionid");
                studentSectionTransactionIDHash = studentScheduleViewPart.data("studentsectiontransactionid_securityhash");
            }

            var data =
            {
                "Workflow.studentsectionid": studentSectionID,
                "Workflow.studentsectionid_securityhash": studentSectionIDHash,
                "Workflow.studentsectiontransactionid": studentSectionTransactionID,
                "Workflow.studentsectiontransactionid_securityhash": studentSectionTransactionIDHash,
                "Workflow.effectivedate": effectiveDate,
                "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                "Workflow.entityid_securityhash": studentScheduleViewPart.data('entityid_securityhash')
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/EditStudentSection", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.viewSchedule = function (event)
        {
            skyward.window.loadContent('full', 'Scheduling', 'StudentSchedule', 'StudentProfileViewStudentSchedule', studentScheduleViewPart.data('studentid'), getPrintData());
        };

        var getPrintData = function ()
        {
            var rawData = studentScheduleViewPart.data();
            // copy data from studentScheduleViewPart, skipping Objects and Arrays
            var data = Object.keys(rawData).reduce(function (result, key)
            {
                if (typeof (rawData[key]) !== "object")
                {
                    result[key] = rawData[key];
                }
                return result;
            }, {});
            return $.extend({
                // These keys must be specified explicitly since they differ from the data attribute name
                "lowdate": studentScheduleViewPart.data('startdate'),
                "highdate": studentScheduleViewPart.data('enddate')
            }, data);
        };

        skyward.matrix.printSchedule = function (event)
        {
            var url = skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/PrintScheduleMatrix" + studentScheduleViewPart.data("viewmode");
            skyward.printScreen.launchWorkflow(url, getPrintData());
        };

        var validateStudentSectionTransactionEndDate = function (action)
        {
            var startDate = skyward.time.parseDate(studentScheduleViewPart.data("studentsectionstartdate"));
            var endDate = skyward.time.parseDate(studentScheduleViewPart.data("studentsectionenddate"));
            var effectiveDate = getEffectiveDate();

            if (effectiveDate < startDate)
            {
                skyward.modalLayer.showCriticalDialog("Invalid Effective Date",
                    "The End Date for the Student Section to " + action + " must be on or after " +
                    (startDate.getMonth() + 1) + "/" + startDate.getDate() + "/" + startDate.getFullYear() + ".");
                return false;
            }
            else if (effectiveDate > endDate)
            {
                skyward.modalLayer.showCriticalDialog("Invalid Effective Date",
                    "The End Date for the Student Section to " + action + " must be on or before " +
                    (endDate.getMonth() + 1) + "/" + endDate.getDate() + "/" + endDate.getFullYear() + ".");
                return false;
            }

            return true;
        };

        var setActiveStudentSectionOrRequest = function (studentCourseRequestID, studentSectionID)
        {
            studentScheduleViewPart.data("activeStudentSectionCard", studentScheduleViewPart.data("selectedStudentSection"));
            studentScheduleViewPart.data("activeStudentSectionOrRequest", { studentSectionID: studentSectionID, studentCourseRequestID: studentCourseRequestID });
        };

        var activateSelectedRow = function (browseName, studentCourseRequestID, studentSectionID)
        {
            if (browseName == studentCourseRequestBrowse)
            {
                deactivateSelectedRow(true);
                setActiveStudentSectionOrRequest(studentCourseRequestID, studentSectionID);

                var browse = getBrowseByName(browseName);

                if (studentCourseRequestID != "")
                {
                    var activeRowIndex = getStudentCourseRequestRowIndex(studentCourseRequestID);

                    if (activeRowIndex != -1 && browse)
                    {
                        var lockedRow = skyward.browse.getCurrentRowElement("locked", browse.browseName, activeRowIndex);
                        var unlockedRow = skyward.browse.getCurrentRowElement("unlocked", browse.browseName, activeRowIndex);

                        lockedRow.addClass("studentCourseRequest selectedRow");
                        lockedRow.find("svg.selectedRow").addClass("studentCourseRequest");
                        unlockedRow.addClass("studentCourseRequest selectedRow").removeClass("current");
                        unlockedRow.find("> td").addClass("browseRowCell selectedRow");
                    }
                }
            }
        };

        var deselectPreviousRowOverride = function (browseName)
        {
            if (browseName == studentCourseRequestBrowse)
            {
                var browse = getBrowseByName(browseName);
                var studentCourseRequestID = studentScheduleViewPart.data("activeStudentSectionOrRequest")["studentCourseRequestID"];

                if (studentCourseRequestID != "")
                {
                    var activeRowIndex = getStudentCourseRequestRowIndex(studentCourseRequestID);

                    if (!(activeRowIndex != -1 && browse && browse.currentRow != activeRowIndex))
                    {
                        return false;
                    }
                }
            }
            return true;
        };

        var deactivateSelectedRow = function (forceDeselect)
        {
            var browse = getBrowseByName(studentCourseRequestBrowse);
            var studentCourseRequestID = studentScheduleViewPart.data("activeStudentSectionOrRequest")["studentCourseRequestID"];

            if (studentCourseRequestID != "" && browse)
            {
                var activeRowIndex = getStudentCourseRequestRowIndex(studentCourseRequestID);

                if (activeRowIndex > -1)
                {
                    var lockedRow = skyward.browse.getCurrentRowElement("locked", browse.browseName, activeRowIndex);
                    var unlockedRow = skyward.browse.getCurrentRowElement("unlocked", browse.browseName, activeRowIndex);

                    if (!forceDeselect)
                    {
                        if (activeRowIndex == browse.currentRow)
                        {
                            lockedRow.removeClass("studentCourseRequest selectedRow");
                            lockedRow.find("svg.selectedRow").removeClass("studentCourseRequest");
                            unlockedRow.removeClass("studentCourseRequest selectedRow").addClass("current");
                            unlockedRow.find("> td").removeClass("browseRowCell selectedRow");
                        }
                        else //This happens when the arrow up/down keys are pressed during active session and the current is no longer the same as the active (selectedRow)
                        {
                            forceDeselect = true;
                        }
                    }

                    if (forceDeselect)
                    {
                        lockedRow.removeClass("studentCourseRequest selectedRow current");
                        lockedRow.find("svg.selectedRow").removeClass("studentCourseRequest");
                        lockedRow.find("> td").removeClass("browseRowCell selectedRow");

                        unlockedRow.removeClass("studentCourseRequest selectedRow current");
                        unlockedRow.find("svg.selectedRow").removeClass("studentCourseRequest");
                        unlockedRow.find("> td").removeClass("browseRowCell selectedRow");
                    }
                }
            }

            studentScheduleViewPart.data("activeStudentSectionCard", "");
            setActiveStudentSectionOrRequest("", "");
        };

        //Quick Entry Panel
        var toggleQuickEntry = function ()
        {
            var scheduleBuilderQuickEntryToolbarVisible;
            var quickEntryToolbar = $('#quickEntryToolbar');
            var contentWrapper = $('#studentScheduleContentWrapper');
            var btnCourseQuickEntry = $(btnCourseQuickEntryID);

            if (quickEntryToolbar.hasClass('hidden') && !contentWrapper.hasClass('quickEntryVisible'))
            {
                //Quick Entry Panel is not visible, so the content wrapper should not be adjusted
                quickEntryToolbar.removeClass('hidden');
                contentWrapper.addClass('quickEntryVisible');
                scheduleBuilderQuickEntryToolbarVisible = true;
                btnCourseQuickEntry.removeClass("collapsed").addClass("expanded");
                $(quickEntryCourseEELID + '_code').focus();
            }
            else
            {
                quickEntryToolbar.addClass('hidden');
                contentWrapper.removeClass('quickEntryVisible');
                scheduleBuilderQuickEntryToolbarVisible = false;
                btnCourseQuickEntry.removeClass("expanded").addClass("collapsed");
            }

            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/UpdateQuickEntryToolbarState",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    ScheduleBuilderQuickEntryToolbarVisible: scheduleBuilderQuickEntryToolbarVisible
                }
            });
        };

        var clearQuickEntry = function ()
        {
            var btnQuickEntryToolbarClear = $(quickEntryToolbarClearButtonID);
            if (btnQuickEntryToolbarClear && !btnQuickEntryToolbarClear.hasClass('hidden'))
            {
                var courseEEL = $(quickEntryCourseEELID);
                if (courseEEL && courseEEL.find('.codeEELValue').val() != '')
                {
                    skyward.codeeel.clear($(quickEntryCourseEELID), true);
                    $(quickEntryCourseEELID + '_code').focus();
                }
            }
        };

        var addFromQuickEntry = function ()
        {
            var btnQuickEntryToolbarAddCourse = $(quickEntryToolbarAddCourseButtonID);
            if (btnQuickEntryToolbarAddCourse && !btnQuickEntryToolbarAddCourse.hasClass('hidden'))
            {
                var entityID = studentScheduleViewPart.data("entityid");
                var entityIDSecurityHash = studentScheduleViewPart.data('entityid_securityhash');

                var studentID = btnQuickEntryToolbarAddCourse.data('studentid');
                var studentIDSecurityHash = btnQuickEntryToolbarAddCourse.data('studentid_securityhash');

                var courseEEL = $(quickEntryCourseEELID);
                if (courseEEL)
                {
                    var courseEELValue = courseEEL.find('.codeEELValue').val();
                    if (courseEELValue)
                    {
                        var sectionEEL = $(quickEntrySectionEELID);
                        if (sectionEEL)
                        {
                            var sectionEELValue = sectionEEL.find('.codeEELValue').val();
                            if (sectionEELValue)
                            {
                                //Get the end date from the section that was selected
                                $.ajax({
                                    url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/GetSectionEndDateForQuickEntryToolbar",
                                    type: "POST",
                                    dataType: "JSON",
                                    data:
                                    {
                                        sectionID: sectionEELValue
                                    },
                                    success: function (data)
                                    {
                                        if (data && !$.isEmptyObject(data))
                                        {
                                            var startDate = studentScheduleViewPart.data("effectivedate");
                                            var sectionID_securityhash = data.sectionid_securityhash;
                                            skyward.matrix.addStudentSectionFromBrowseMenu(sectionEELValue, sectionID_securityhash, startDate, data.EndDate);
                                        }
                                    }
                                });
                            }
                            else
                            {
                                skyward.matrix.addCourseRequest(courseEELValue, entityID, entityIDSecurityHash, studentID, studentIDSecurityHash);
                            }
                        }
                        else
                        {
                            skyward.matrix.addCourseRequest(courseEELValue, entityID, entityIDSecurityHash, studentID, studentIDSecurityHash);
                        }
                    }
                }
                $(quickEntryCourseEELID + '_code').focus();
            }
        };

        var updateAddCourseButton = function ()
        {
            var courseEEL = $(quickEntryCourseEELID + '_value');
            var btnQuickEntryToolbarAddCourse = $(quickEntryToolbarAddCourseButtonID);
            var btnQuickEntryToolbarClear = $(quickEntryToolbarClearButtonID);
            if (courseEEL && courseEEL.val() != undefined && courseEEL.val() == "")
            {
                btnQuickEntryToolbarAddCourse.addClass('hidden');
                btnQuickEntryToolbarClear.addClass('hidden');
            }
            else
            {
                btnQuickEntryToolbarAddCourse.removeClass('hidden');
                btnQuickEntryToolbarClear.removeClass('hidden');
            }
        };

        var buildMessageBoxErrorList = function (errorList, errors)
        {
            $(errors).each(function ()
            {
                for (var key in this)
                {
                    for (var i = 0; i < errors[key].length; i++)
                    {
                        var iconSpan = $('<span/>');
                        $.when(skyward.svg.getSvg('Error', 'Error')).done(function (svg)
                        {
                            iconSpan.append(svg);
                        });
                        var listItem = $("<li class='error-list'/>");
                        var errorMessage = $('<span>' + errors[key][i] + '</span>');
                        listItem.append(iconSpan);
                        listItem.append(errorMessage);
                        errorList.append(listItem);
                    }
                }
            });
        };

        var bottomTabCourseContainerSetFirstTabCurrent = function ()
        {
            var tabButtonList = bottomTabCourseContainer.find(".tabStrip .tabButton");
            var tabContentsList = bottomTabCourseContainer.find(".tabContents");
            tabButtonList.each(function ()
            {
                var tab = $(this);

                if (tab.hasClass("firstTab"))
                {
                    tab.addClass("current");
                    tabContentsList.removeClass("current");
                    $(tabContentsList[tab.data("index")]).addClass("current");
                }
                else
                {
                    tab.removeClass("current");
                }
            });
        };

        var loadCourseTabContainer = function (currentTab)
        {
            var currentTabContent = findContentContainerFromCurrentTab(currentTab);
            if (currentTabContent != undefined)
            {
                var contentContainer = currentTabContent.contentContainer;
                var loadBrowse = currentTabContent.loadBrowse;
                var contentContainerID = contentContainer.attr("id");

                if (contentContainerID != undefined && contentContainerID != "")
                {
                    var browseName = contentContainerID.replace("View", "");

                    if (loadBrowse)
                    {
                        contentContainer.data("browseLoaded", false);

                        var data = {
                            studentid: studentScheduleViewPart.data('studentid'),
                            studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                            coursecontainer: contentContainerID,
                            effectivedate: studentScheduleViewPart.data("effectivedate"),
                        };
                        skyward.window.loadContent(contentContainerID, 'Scheduling', 'StudentSchedule', 'Get' + browseName, null, data, null, null, null, true);
                    }
                }
            }
        };

        var getBottomTabCourseContainerPanelInfo = function (infoToGet)
        {
            var panelInfo = bottomTabCourseContainer.data("panelinfo");

            if (panelInfo != undefined)
            {
                switch (infoToGet)
                {
                    case "displayPanel":
                        if (panelInfo.displayPanel != undefined)
                        {
                            return { displayPanel: panelInfo.displayPanel };
                        }
                        else
                        {
                            return { displayPanel: false };
                        }
                    case "currentTab":
                        if (panelInfo.currentTab != undefined)
                        {
                            return { currentTab: panelInfo.currentTab };
                        }
                        else
                        {
                            return { currentTab: undefined };
                        }
                    case "displayPanelAndcurrentTab":
                        if (panelInfo.displayPanel != undefined && panelInfo.currentTab != undefined)
                        {
                            return { displayPanel: panelInfo.displayPanel, currentTab: panelInfo.currentTab };
                        }
                        break;
                }
            }

            return { displayPanel: false, currentTab: undefined };
        };

        var bottomTabCourseContainerSearchBoxSetFocus = function (currentTab)
        {
            const currentTabContent = findContentContainerFromCurrentTab(currentTab);
            if (currentTabContent.contentContainer === undefined)
            {
                return;
            }
            const browse = skyward.browse.getInnerBrowse(currentTabContent.contentContainer);
            if (browse !== undefined && browse.seek !== undefined)
            {
                browse.seek.focus();
            };
            return browse;
        };

        var bottomTabCourseContainerResizeAndSearchBoxSetFocus = function (currentTab)
        {
            const browse = bottomTabCourseContainerSearchBoxSetFocus(currentTab);
            if (browse !== undefined)
            {
                skyward.browse.resize(browse.id);
            }
        };

        var getbottomTabContainerLoadedBrowse = function ()
        {
            var loadedBrowse = "";
            var availableSectionViewBrowseLoaded = $("#" + availableSectionsView).data("browseLoaded");
            if (availableSectionViewBrowseLoaded != undefined)
            {
                switch (availableSectionViewBrowseLoaded)
                {
                    case availableSectionsBrowse:
                        loadedBrowse = availableSectionsBrowse;
                        break;
                    case availableSectionsByRequestsAndOpenPeriodBrowse:
                        loadedBrowse = availableSectionsByRequestsAndOpenPeriodBrowse;
                        break;
                    case availableSectionsByOpenPeriodBrowse:
                        loadedBrowse = availableSectionsByOpenPeriodBrowse;
                        break;
                    case availableSectionsByChangeSectionBrowse:
                        loadedBrowse = availableSectionsByChangeSectionBrowse;
                        break;
                    case availableSectionsByReplaceSectionBrowse:
                        loadedBrowse = availableSectionsByReplaceSectionBrowse;
                        break;
                }
            }

            return loadedBrowse;
        };

        var bottomTabContainerSearchBoxSetFocus = function ()
        {
            var loadedBrowse = getbottomTabContainerLoadedBrowse();
            if (loadedBrowse != "")
            {
                skyward.browse.resize(loadedBrowse);
                $("#" + loadedBrowse + "_seek").focus();
            }
        };

        //Schedule Matrix Display Settings
        var showSettingsDialog = function ()
        {
            var selector = $(this);
            var action = selector.data("action");

            var saveSettings = function ()
            {
                const dayRotationDMSE = $('#FilterDayRotationCodes .dmsBackingData');
                const dayRotationCodes = JSON.stringify(skyward.distinctmultiselecteel.getValue(dayRotationDMSE));

                //Find the selected schedule card size radio button
                var selectedViewSize = $('#rsScheduleMatrixViewSize_RadioButtonGroup').find('input:checked').val();

                // Find user label configurations, if any
                var serializedScheduledLabelConfiguration = "";
                var userLabelConfigurations = $('.js-ScheduledFieldToDisplay');
                if (userLabelConfigurations.length > 0)
                {
                    var scheduledLabelConfiguration = {};
                    userLabelConfigurations.each(function ()
                    {
                        var optionCombobox = $(this);
                        // substr(9) removes the "Scheduled" string from the front of the id to sanitize it for serialization
                        scheduledLabelConfiguration[optionCombobox.attr('id').substr(9)] = skyward.controls.getValue(optionCombobox);
                    });
                    serializedScheduledLabelConfiguration = JSON.stringify(scheduledLabelConfiguration);
                }

                var viewmode = studentScheduleViewPart.data('viewmode');
                if (AccessMode == "StudentAccess")
                {
                    viewmode = AccessMode;
                }

                $.ajax({
                    url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/UpdateStudentScheduleMatrixViewSize" + viewmode,
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        StudentScheduleMatrixViewSize: selectedViewSize,
                        ScheduledFieldsToDisplay: serializedScheduledLabelConfiguration,
                        DayRotationsToDisplay: dayRotationCodes
                    },
                    success: function ()
                    {
                        skyward.window.closePopup();
                        skyward.matrix.updateBoard();
                    }
                });
            };

            var buildSettingsDialog = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/" + action + "?renderType=contentOnly",
                    type: "POST",
                    dataType: "viewparthtml",
                });
            };

            var options =
            {
                draggable: "true"
            };

            var htmlResponse = buildSettingsDialog();
            htmlResponse.done(function (html)
            {
                var htmlElement = $(html);
                var isFamilyStudentAccess = skyward.controls.getValue(htmlElement.find("#isFamilyStudentAccess"));
                var matrixOrBuilderString = $("#master").attr("data-screen");
                isFamilyStudentAccess = JSON.parse(isFamilyStudentAccess.toLowerCase());
                var headerText = "Schedule Matrix Display Settings";
                if (matrixOrBuilderString == "ScheduleBuilder")
                {
                    headerText = "Student Schedule Builder Display Settings";
                }
                if (isFamilyStudentAccess != null && isFamilyStudentAccess)
                {
                    headerText = "Student Schedule Display Settings";
                }
                var buttons = [{ id: 'btnSettingsSave', text: 'Save', icon: 'Save', click: saveSettings }, { text: 'Close', icon: 'Close', click: 'close' }];

                var dialog = skyward.modalLayer.showDialog(headerText, html, buttons, options);

                dialog.content.find('.js-ResetScheduledFieldsButton').click(function ()
                {
                    var serializedDefaultFieldsElement = dialog.content.find('.js-DefaultScheduledFields');

                    if (serializedDefaultFieldsElement.length === 0 || !serializedDefaultFieldsElement.val())
                    {
                        return;
                    }

                    var defaultFields = JSON.parse(serializedDefaultFieldsElement.val());

                    if ($.isEmptyObject(defaultFields))
                    {
                        return;
                    }

                    dialog.content.find('.js-ScheduledFieldToDisplay').each(function ()
                    {
                        var optionCombobox = $(this);
                        // substr(9) removes the "Scheduled" string from the front of the id to sanitize it for serialization

                        var defaultValueForCombobox = defaultFields[optionCombobox.attr('id').substr(9)];
                        if (!defaultValueForCombobox)
                        {
                            return;
                        }

                        skyward.controls.setValue(optionCombobox, defaultValueForCombobox);
                    });
                });
            });
        };

        var buildScheduleBuilderLegendPopup = function ()
        {
            var clickedElement = $(this);
            var viewmode = studentScheduleViewPart.data("viewmode");
            var accessMode = clickedElement.parents(".studentInformationPopupTabPanel").find("[id$='accessmode']").val() || $("[id$='accessmode']").val();

            if (accessMode == "StudentAccess")
            {
                viewmode = accessMode;
            }

            if (viewmode == "StudentInformationPopup")
            {
                viewmode = viewmode + accessMode;
            }

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/BuildScheduleLegendPopup" + viewmode + "/",
                    type: "POST",
                    dataType: "viewparthtml",
                });
            };
            var beforeClose = function ()
            {
                clickedElement.off().on('click', buildScheduleBuilderLegendPopup);
            };

            clickedElement.off('click', buildScheduleBuilderLegendPopup);

            var legendTitle = studentScheduleViewPart.data("viewmode") == "Builder" ? "Schedule Builder Legend" : "Schedule Matrix Legend";
            skyward.modalLayer.showDialog(legendTitle, buildPopup, { text: "Ok", icon: "Check" }, { anchorTo: clickedElement, beforeClose: beforeClose });
        };

        //Utilities drop down
        var updateStudentScheduleUtilities = function ()
        {
            var clickedElement = $(this);
            var viewmode = studentScheduleViewPart.data("viewmode");

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/UpdateStudentScheduleUtilities" + viewmode + "/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        studentid: clickedElement.data("studentid"),
                        studentidSecurityHash: clickedElement.data("studentid_securityhash"),
                        entityid: clickedElement.data("entityid"),
                        entityidSecurityHash: clickedElement.data("entityid_securityhash"),
                        schoolyearid: clickedElement.data("schoolyearid"),
                        schoolyearidSecurityHash: clickedElement.data("schoolyearid_securityhash")
                    },
                });
            };
            skyward.modalLayer.showInformationBubble("Utilities", buildPopup, null, { anchorTo: clickedElement, useSmallWidth: true });
        };

        //Student/Family Access Printing
        var daterangemode;
        var selectedWeek;
        var weeklyScheduleName = "WeeklySchedule";

        const getStudentAccessFamilyAccessSelectedOptions = function ()
        {
            daterangemode = $("#cbScheduleDateRangeMode").val();
            selectedWeek = (daterangemode === weeklyScheduleName) ? $("#cbWeekOfYear").val() : "";
        };

        skyward.matrix.printAllSchedulesStudentFamilyAccess = function ()
        {
            var masterDiv = $("#master");
            var module = $(masterDiv).data("module");
            var object = $(masterDiv).data("object");
            var portal = $(masterDiv).data("screen");
            getStudentAccessFamilyAccessSelectedOptions();

            var studentEntityYearIDs = [];
            var studentids = [];
            var studentid_securityHashes = [];

            $(".studentScheduleMatrix").each(function ()
            {
                portal = $(this).data('portal');
                studentEntityYearIDs.push($(this).data('uniqueid'));
                studentids.push($(this).data('studentid'));
                studentid_securityHashes.push($(this).data('studentid_securityhash'));
            });

            if (studentEntityYearIDs.length === 0)
            {
                skyward.modalLayer.showDialog("Schedule Not Available to Print", "Scheduling and Grading Information is not available.", { text: "Ok", icon: "Check" });
                return;
            }

            skyward.printScreen.launchWorkflow(skyward.global.virtualDir + module + "/" + object + "/PrintAllScheduleMatrices" + portal,
                {
                    studententityyearids: JSON.stringify(studentEntityYearIDs),
                    studentids: JSON.stringify(studentids),
                    studentid_securityHashes: JSON.stringify(studentid_securityHashes),
                    "daterangemode": daterangemode,
                    "displayweeklyschedulefor": selectedWeek
                });
        };

        skyward.matrix.printIndividualScheduleStudentFamilyAccess = function (studentEntityYearID)
        {
            var masterDiv = $("#master");
            var module = $(masterDiv).data("module");
            var object = $(masterDiv).data("object");
            var portal = $(masterDiv).data("screen");
            getStudentAccessFamilyAccessSelectedOptions();

            var scheduleMatrix = $("#studentSchedule-" + studentEntityYearID);

            skyward.printScreen.launchWorkflow(skyward.global.virtualDir + module + "/" + object + "/PrintIndividualScheduleMatrix" + portal,
                {
                    "entityid": $(scheduleMatrix).data('entityid'),
                    "schoolyearid": $(scheduleMatrix).data('schoolyearid'),
                    "schoolyearid_securityhash": $(scheduleMatrix).data("schoolyearid_securityhash"),
                    "studentid": $(scheduleMatrix).data('studentid'),
                    "studentid_securityhash": $(scheduleMatrix).data('studentid_securityhash'),
                    "effectivedate": $(scheduleMatrix).data("effectivedate"),
                    "daterangemode": daterangemode,
                    "displayweeklyschedulefor": selectedWeek
                });
        };

        // Event handlers
        var events =
        {
            "editStudentSection": skyward.matrix.editStudentSection,
            "addCourseRequest": addCourseRequest,
            "addStudentSectionFromBrowseMenu": addStudentSectionFromBrowseMenu,
            "addStudentSectionFromScheduleListBrowseMenu": skyward.matrix.addStudentSectionFromScheduleListBrowseMenu,
            "updateBottomTabContainerFromCourseBrowseMenu": skyward.matrix.updateBottomTabContainerFromCourseBrowseMenu,
            "updateBottomTabContainerFromRequestBrowseMenu": skyward.matrix.updateBottomTabContainerFromRequestBrowseMenu,
            "unscheduleStudentSectionFromBrowseMenu": skyward.matrix.unscheduleStudentSectionFromBrowseMenu,
            "deleteStudentSectionFromBrowseMenu": skyward.matrix.deleteStudentSection,
            "deleteStudentSectionFromScheduleListBrowseMenu": skyward.matrix.deleteStudentSectionFromScheduleListBrowseMenu,
            "changeStudentSectionFromBrowseMenu": skyward.matrix.changeStudentSectionFromBrowseMenu,
            "changeStudentSectionFromScheduleListBrowseMenu": skyward.matrix.changeStudentSectionFromScheduleListBrowseMenu,
            "updateAvailableSectionsFromChangeSectionBrowseMenu": skyward.matrix.updateAvailableSectionsFromChangeSectionBrowseMenu,
            "dropStudentSectionfromBrowseMenu": skyward.matrix.dropStudentSectionfromBrowseMenu,
            "dropStudentSectionFromScheduleListBrowseMenu": skyward.matrix.dropStudentSectionFromScheduleListBrowseMenu,
            "replaceStudentSectionWorkflow": skyward.matrix.replaceStudentSectionWorkflow,
            "updateAvailableSectionsFromReplaceSection": skyward.matrix.updateAvailableSectionsFromReplaceSection,
            "updateAvailableSectionsFromReplaceSectionBrowseMenu": skyward.matrix.updateAvailableSectionsFromReplaceSectionBrowseMenu,
            "deleteCourseRequestFromBrowseMenu": skyward.matrix.deleteCourseRequestFromBrowseMenu,
            "unscheduleStudentSectionFromScheduleListBrowseMenu": skyward.matrix.unscheduleStudentSectionFromScheduleListBrowseMenu,
            "replaceStudentSectionFromScheduleListBrowseMenu": skyward.matrix.replaceStudentSectionFromScheduleListBrowseMenu,
            "addStudentCourseRequestOrAlternatesFromScheduleListBrowseMenu": skyward.matrix.addStudentCourseRequestOrAlternatesFromScheduleListBrowseMenu,
            "addStudentCourseRequestOrAlternatesFromScheduleRequestBrowseMenu": skyward.matrix.addStudentCourseRequestOrAlternatesFromScheduleRequestBrowseMenu,
            "deleteStudentCourseRequestFromScheduleListBrowseMenu": skyward.matrix.deleteStudentCourseRequestFromScheduleListBrowseMenu,
            "deleteStudentCourseRequestFromCourseRequestBrowseMenu": skyward.matrix.deleteStudentCourseRequestFromCourseRequestBrowseMenu,
            "callIndividualStudentSchedulerFromScheduleList": skyward.matrix.callIndividualStudentSchedulerFromScheduleList,
            "callIndividualStudyHallSchedulerFromScheduleList": skyward.matrix.callIndividualStudyHallSchedulerFromScheduleList,
            "callReactivateStudentScheduleFromScheduleList": skyward.matrix.callReactivateStudentScheduleFromScheduleList,
            "callReactivateStudentScheduleFromScheduleRequests": skyward.matrix.callReactivateStudentScheduleFromScheduleRequests,
            "callIndividualStudentSchedulerFromScheduleBuilder": skyward.matrix.callIndividualStudentSchedulerFromScheduleBuilder,
            "callIndividualStudyHallSchedulerFromScheduleBuilder": skyward.matrix.callIndividualStudyHallSchedulerFromScheduleBuilder,
            "callReactivateStudentScheduleFromScheduleBuilder": skyward.matrix.callReactivateStudentScheduleFromScheduleBuilder,
            "IndividualAddBySchedulingGroupFromScheduleList": skyward.matrix.IndividualAddBySchedulingGroupFromScheduleList,
            "IndividualAddBySchedulingGroupFromScheduleBuilder": skyward.matrix.IndividualAddBySchedulingGroupFromScheduleBuilder,
            "IndividualAddBySchedulingGroupFromScheduleRequests": skyward.matrix.IndividualAddBySchedulingGroupFromScheduleRequests,
            "IndividualMassDropOrDeleteStudentScheduleFromScheduleList": skyward.matrix.IndividualMassDropOrDeleteStudentScheduleFromScheduleList,
            "IndividualMassDropOrDeleteStudentScheduleFromScheduleBuilder": skyward.matrix.IndividualMassDropOrDeleteStudentScheduleFromScheduleBuilder,
            "IndividualMassUnscheduleStudentSectionsFromScheduleList": skyward.matrix.IndividualMassUnscheduleStudentSectionsFromScheduleList,
            "IndividualMassUnscheduleStudentSectionsFromScheduleBuilder": skyward.matrix.IndividualMassUnscheduleStudentSectionsFromScheduleBuilder,
            "addStudentCourseRequestOrAlternatesFromScheduleBuilder": skyward.matrix.addStudentCourseRequestOrAlternatesFromScheduleBuilder,
            "updateStudentScheduleUtilities": updateStudentScheduleUtilities,
            "printIndividualScheduleStudentFamilyAccess": skyward.matrix.printIndividualScheduleStudentFamilyAccess,
            "printAllSchedulesStudentFamilyAccess": skyward.matrix.printAllSchedulesStudentFamilyAccess
        };
        skyward.events.registerEvents("matrix", events);

        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
